import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { faPlus, faMinus, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt, faTimesCircle, faCalendarAlt, faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CalculatorService } from 'src/app/shared/services/calculator-services/calculator-standard-os.service';
import { formatDate } from '@angular/common';
import { ScholarshipPremium } from 'src/app/shared/models/calculator-models/scholarship-premium';
import { Subscription } from 'rxjs';
import { BasicInformations } from 'src/app/shared/models/basic-informations.model';
import { BasicInformationsService } from 'src/app/shared/services/basic-informations.service';
import { ExportCalculatorService } from 'src/app/shared/services/calculator-services/calculator-export.service';
import { ProductRoleService } from 'src/app/shared/services/admin-services/product-role.service';
import { ScholershipPremiumExport } from 'src/app/shared/models/export-models/scholarship-premium-export.model';
import { Beneficiaries } from 'src/app/shared/models/offer-models/beneficiaries.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OfferService } from 'src/app/shared/services/offer-services/offer.service';
import { OccupationService } from 'src/app/shared/services/admin-services/occupation.service';
import { UserService } from 'src/app/shared/services/admin-services/user.service';
import { BankService } from 'src/app/shared/services/admin-services/bank.service';
import { DigitalService } from 'src/app/shared/services/digital.service';
import { SendingSumAndPremiumInfoService } from 'src/app/shared/services/sending-sum-and-premium-info.service';
import { InsuranceSumAndPremium } from 'src/app/shared/models/insurance-sum-and-premium.model';
import { PLATIMATICQuestionnaire } from 'src/app/shared/models/offer-models/platimatik-questionnaire.model';
import { SPNFTQuestionnaire } from 'src/app/shared/models/offer-models/spnft-questionnaire.model';
import { FATCAQuestionnaire } from 'src/app/shared/models/offer-models/fatca-questionnaire.model';
import { HealthQuestionnaire } from 'src/app/shared/models/offer-models/health-questionnaire.model';
import { OfferInsuree } from 'src/app/shared/models/offer-models/offer-insuree.model';
import { OfferClient } from 'src/app/shared/models/offer-models/offer-client.model';
import { StandardOSOffer } from 'src/app/shared/models/offer-models/standard-os-offer.model';
import { Filter } from 'src/app/shared/models/filter.model';
import { Router } from '@angular/router';
import { RoleSendService } from 'src/app/shared/services/role-send.service';
import { RiskAssessment } from 'src/app/shared/models/offer-models/risk-assessment.model';
import { RedemptionAndCapitalizations } from 'src/app/shared/models/offer-models/redemption-capitalization-model';
import { RemoveInfoService } from 'src/app/shared/services/remove-info.service';
import { SaveDraftService } from 'src/app/shared/services/save-draft.service';
import { SendInfoService } from 'src/app/shared/services/send-info.service';

@Component({
  selector: 'app-scholarship-calculation-premium',
  templateUrl: './scholarship-calculation-premium.component.html',
  styleUrls: ['./scholarship-calculation-premium.component.sass']
})
export class ScholarshipCalculationPremiumComponent implements OnInit, OnDestroy {
  @ViewChild('insuredBlock', { static: false }) private insuredBlock;
  @ViewChild('usersBlock', { static: false }) private usersBlock;
  @ViewChild('healthBlock', { static: false }) private healthBlock;
  @ViewChild('spnftBlock', { static: false }) private spnftBlock;
  @ViewChild('platimatikBlock', { static: false }) private platimatikBlock;
  @ViewChild('fatcaBlock', { static: false }) private fatcaBlock;
  faPlus = faPlus;
  faMinus = faMinus;
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faTrashAlt = faTrashAlt;
  faTimesCircle = faTimesCircle;
  faCalendarAlt = faCalendarAlt;
  faCheckCircle = faCheckCircle;

  @ViewChild('alertModal', { static: false }) private alertModal;
  @ViewChild('emailModal', { static: false }) private emailModal;
  @ViewChild('succesModal', { static: false }) private succesModal;
  @ViewChild('accNumber', { static: false }) private accNumber;
  errorTitle: String;
  successTitle: String;

  basicInfoSubscription: Subscription;
  sumAndPremiumInfoSubscription: Subscription;
  roleService: Subscription;

  roleType: String = '';

  basicInfo: BasicInformations;
  sentInformations;
  standardTableArray: Array<any>;

  insuredSumANdPremimBool: Boolean = true;
  basicCaseBool: Boolean = true;
  calculcatorUsersBool: Boolean = false;
  supplementaryInsuranceBool: Boolean = true;
  supplementaryIsnuranceHideAllBool: Boolean = true;
  healthQuestionnaireBool: Boolean = false;
  noticePersonalityBool: Boolean = false;
  noticeFatcaBool: Boolean = false;
  fatcaTypeBool: Boolean = null;
  formSpnftBool: Boolean = false;
  formPlatimatikBool: Boolean = false;
  hideExport: Boolean = false;

  // Forma za osiguranu sumu i premiju
  insuredSumAndPremiumForm = new FormGroup({
    insuranceStart: new FormControl({ value: '', disabled: true }),
    insuranceEnd: new FormControl({ value: '', disabled: true }),
    insurancePeriod: new FormControl({ value: '', disabled: true }),
    // occupation: new FormControl('', [Validators.required]),
    accessAge: new FormControl('', [Validators.required]),
    gender: new FormControl('', [Validators.required]),
    scholarshipPeriodPayment: new FormControl({ value: '5', disabled: true }),
    dynamicsOfPayment: new FormControl('', [Validators.required]),
    scholarshipPeriodPayout: new FormControl('', [Validators.required]),
    currencyPayment: new FormControl('0', [Validators.required]),
    currencyPayout: new FormControl('0', [Validators.required]),
    indexation: new FormControl('', [Validators.required]),
    methodPayment: new FormControl('', [Validators.required])
  })

  // Forma za osigurani slucaj
  basicInfoForm = new FormGroup({
    insuranceSum: new FormControl('', [Validators.required]),
    insuraceSumSupp: new FormControl({ value: '', disabled: true }),
    premiumRate: new FormControl({ value: '', disabled: true }),
    premiumRateSupp: new FormControl({ value: '', disabled: true }),
    cigarettesDaily: new FormControl('0', [Validators.required]),
    deathSuppInsurance: new FormControl('0', [Validators.required]),
    height: new FormControl('', [Validators.required]),
    weight: new FormControl('', [Validators.required]),
    noSupplementaryInsurance: new FormControl(false, [])
  })

  // Forma za Dopusnko osiguranje
  insuranceCoverageForm = new FormGroup({
    deathByAccident: new FormControl({ value: '', disabled: true }),
    invalidityByAccident: new FormControl({ value: '', disabled: true }),
    surgery: new FormControl({ value: '', disabled: true }),
    monthlyRent: new FormControl({ value: '', disabled: true }),
    dailyFee: new FormControl({ value: '', disabled: true }),
    accidentPlan: new FormControl('3', []),
    premiumCoverageRateFirst: new FormControl({ value: '', disabled: true }),
    premiumCoverageRateSecond: new FormControl({ value: '', disabled: true }),
    premiumCoverageRateThird: new FormControl({ value: '', disabled: true }),
    premiumCoverageRateForth: new FormControl({ value: '', disabled: true }),
    sumPremiumRateFirst: new FormControl({ value: '', disabled: true }),
    sumPremiumRateSecond: new FormControl({ value: '', disabled: true }),
    sumPremiumRateThird: new FormControl({ value: '', disabled: true }),
    sumPremiumRateForth: new FormControl({ value: '', disabled: true }),
    sumYearlyFirst: new FormControl({ value: '', disabled: true }),
    sumYearlySecond: new FormControl({ value: '', disabled: true }),
    sumYearlyThird: new FormControl({ value: '', disabled: true }),
    sumYearlyForth: new FormControl({ value: '', disabled: true })
  })

  // Forma za Personalizovano ponuda dopunskog osiguranja
  personalForm = new FormGroup({
    deathByAccident: new FormControl('', []),
    invalidityByAccident: new FormControl('', []),
    surgery: new FormControl({ value: '', disabled: true }),
    monthlyRent: new FormControl({ value: '', disabled: true }),
    daylyFee: new FormControl({ value: '', disabled: true }),
    treatmanExpenses: new FormControl({ value: '', disabled: true }),
    includeMSO: new FormControl({ value: '0', disabled: true }),
    includeDNA: new FormControl({ value: '0', disabled: true }),
    additionalInsurance: new FormControl({ value: '', disabled: true }),

    riderDeath: new FormControl(''),
    tbType: new FormControl(''),
    riderTB: new FormControl(''),

    sumPremiumRateFirst: new FormControl({ value: '', disabled: true }),
    sumYearlyFirst: new FormControl({ value: '', disabled: true }),
  })

  // Forma za cekboksove na dnu
  checkBoxesForm = new FormGroup({
    confirmVeracity: new FormControl(false, []),
    confirmData: new FormControl(false, []),
    confirmSMS: new FormControl('1', []),
    confirmEmail: new FormControl('1', []),
    offer: new FormControl(true, []),
    redemptionAndCapitalization: new FormControl(false, []),
    proContract: new FormControl(false, []),
    terms: new FormControl(false, []),
    doctor: new FormControl(false, [])
  })


  noCovrageForm = new FormGroup({
    sumPremiumRateFirst: new FormControl({ value: '', disabled: true }),
    sumYearlyFirst: new FormControl({ value: '', disabled: true })
  })

  // Lista korisnika
  insuranceUsers: Array<Beneficiaries> = [];
  // Forma za korisnike
  insuranceUserForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    remark: new FormControl('', [Validators.required]),
    role: new FormControl('', [Validators.required])
  })

  // Forma za Zdravstveni upitnik
  healthForm = new FormGroup({
    threeMonthStayAbroad: new FormControl('', [Validators.required]),
    threeMonthStayAbroadDescription: new FormControl('', [Validators.required]),
    deniedAcceptedRequest: new FormControl('', [Validators.required]),
    deniedacceptedRequestDescription: new FormControl('', [Validators.required]),
    sportActivity: new FormControl('', [Validators.required]),
    sportActivityDescription: new FormControl('', [Validators.required]),
    constantDoctorTreats: new FormControl('', [Validators.required]),
    constantDoctorTreatsDescription: new FormControl('', [Validators.required]),
    specialMedicalExamination: new FormControl('', [Validators.required]),
    specialMedicalExaminationDescription: new FormControl('', [Validators.required]),
    takingMedicines: new FormControl('', [Validators.required]),
    takingMedicinesDescription: new FormControl('', [Validators.required]),
    alcoholOrIntoxicants: new FormControl('', [Validators.required]),
    alcoholOrIntoxicantsDescription: new FormControl('', [Validators.required]),
    helpForAlcoholAddiction: new FormControl('', [Validators.required]),
    helpForAlcoholAddictionDescription: new FormControl('', [Validators.required]),
    consumeCigarettes: new FormControl('', [Validators.required]),
    consumeCigarettesDescription: new FormControl('', [Validators.required]),
    seriousIllness: new FormControl('', [Validators.required]),
    seriousIllnessDescription: new FormControl('', [Validators.required]),
    dangerAtWork: new FormControl('', [Validators.required]),
    dangerAtWorkDescription: new FormControl('', [Validators.required]),
    tenYearMedicalTests: new FormControl('', [Validators.required]),
    tenYearmedicalTestsDescription: new FormControl('', [Validators.required]),
    thirtyDaysIncapable: new FormControl('', [Validators.required]),
    thirtyDaysIncapableDescription: new FormControl('', [Validators.required]),
    levelOfInvaliditet: new FormControl('', [Validators.required]),
    levelOfInvaliditetDescription: new FormControl('', [Validators.required]),
    newFifteenthQuestion: new FormControl('', [Validators.required]),
    newFifteenthQuestionDescription: new FormControl('', [Validators.required]),
    nameOfDoctor: new FormControl('', [Validators.required]),
    familySickness: new FormControl('', [Validators.required]),
    familySicknessDescription: new FormControl('', [Validators.required]),
    agreeToHealthQuestionnaire: new FormControl(true, [Validators.required])
  })

  // Forma za Obavestenje FATCA
  fatcaForm = new FormGroup({
    citizenshipSad: new FormControl('1', []),
    texpayerSad: new FormControl('1', []),
    insuredLegalEntitySad: new FormControl('1', []),
    insuredTaxpayerSad: new FormControl('1', []),
    insuredTenPrecentShare: new FormControl('1', []),
    insuredFinancialInstitution: new FormControl('1', [])
  })

  // Forma za Obrazac SPNFT
  spnftForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    companyName: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    legalRepresentativeFirstname: new FormControl('', []),
    legalRepresentativeLastname: new FormControl('', []),
    representativeJmbg: new FormControl('', []),
    dob: new FormControl({ value: '', disabled: true }),
    settlementob: new FormControl('', [Validators.required]),
    pib: new FormControl('', []),
    mb: new FormControl('', []),
    address: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    numberOfDocument: new FormControl('', [Validators.required]),
    typeOfDocument: new FormControl('', [Validators.required]),
    // dateOfIssuringDocument: new FormControl('', [Validators.required]),
    dateOfIssuringDocument: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    personalDocumentExpirationDate: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    placeOfIssuringDocument: new FormControl('', [Validators.required]),
    citizenship: new FormControl('', [Validators.required]),
    officialCloseFamily: new FormControl('0', []),
    closeFamilyName: new FormControl('', []),
    officialPeriod: new FormControl('', []),
    cutomerAnotherPerson: new FormControl('0', [Validators.required]),
    cutomerAnotherPersonRole: new FormControl('', [Validators.required]),
    firstnameOnBehalf: new FormControl('', [Validators.required]),
    lastnameOnBehalf: new FormControl('', [Validators.required]),
    dobOnBehalf: new FormControl({ value: '', disabled: true }),
    settlementobOnBehalf: new FormControl('', [Validators.required]),
    jmbgOnBehalf: new FormControl('', [Validators.required]),
    addressOnBehalf: new FormControl('', [Validators.required]),
    postalCodeOnBehalf: new FormControl('', [Validators.required]),
    settlementOnBehalf: new FormControl('', [Validators.required]),
    idNumberOnBehalf: new FormControl('', [Validators.required]),
    idTypeOnBehalf: new FormControl('', [Validators.required]),
    idDate: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    idPlace: new FormControl('', [Validators.required]),
    purposeOfBusinessRelation: new FormControl('', [Validators.required]),
    purposeOfBusinessRelationOther: new FormControl('', [Validators.required]),
    originOfProperty: new FormControl('', [Validators.required]),
    originOfPropertyOther: new FormControl('', [Validators.required])
  })

  // Forma za Obrazac PLATIMATIK
  platimatikForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    placeOfResidence: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    firstThreeAccountNumber: new FormControl('', [Validators.required]),
    middleAccountNumber: new FormControl('', [Validators.required]),
    lastTwoAccountNumber: new FormControl('', [Validators.required]),
    bankName: new FormControl('', [Validators.required]),
    bankBic: new FormControl('', [Validators.required]),
    validityFirstTermFrom: new FormControl({ value: '', disabled: true }),
    validityFirstTermTo: new FormControl({ value: '', disabled: true }),
    validitySecondTermFrom: new FormControl({ value: '', disabled: true }),
    validitySecondTermTo: new FormControl({ value: '', disabled: true })
    // dateOfFirstObligationsDue: new FormControl('', []),
    // dateOfLastCommitment: new FormControl('', [])
  })

  riskAssessmentForm = new FormGroup({
    question1: new FormControl('', [Validators.required]),
    question2: new FormControl('', [Validators.required]),
    question3: new FormControl('', [Validators.required]),
    question4: new FormControl('', [Validators.required]),
    question5: new FormControl('', [Validators.required]),
    question6: new FormControl('', [Validators.required]),
    question7: new FormControl('', [Validators.required]),
    question8: new FormControl('', [Validators.required]),
    question9: new FormControl('', [Validators.required]),
    question10: new FormControl('', [Validators.required]),
    question11: new FormControl('', [Validators.required]),
    question12: new FormControl('', [Validators.required]),
    question13: new FormControl('', [Validators.required]),
    question14: new FormControl('', [Validators.required]),
    question15: new FormControl('', [Validators.required]),
    question16: new FormControl('', [Validators.required]),
    question17: new FormControl('', [Validators.required]),
    question18: new FormControl('', [Validators.required]),
    question19: new FormControl('', [Validators.required]),
    question20: new FormControl('', [Validators.required]),
    question21: new FormControl('', [Validators.required]),
    question22: new FormControl('', [Validators.required]),
    question23: new FormControl('', [Validators.required]),
    question24: new FormControl('', [Validators.required]),
    question25: new FormControl('', [Validators.required]),
    question26: new FormControl('', [Validators.required]),
    question27: new FormControl('', [Validators.required]),
    question28: new FormControl('', [Validators.required]),
    question29: new FormControl('', [Validators.required]),
    unableToGetData: new FormControl('')
  })

  constructor(private calculatorService: CalculatorService, private basicInformationsService: BasicInformationsService, private exportService: ExportCalculatorService, private productRoleService: ProductRoleService, private modalService: NgbModal, private offerService: OfferService, private occupationService: OccupationService, private userService: UserService, private bankService: BankService, private digitalService: DigitalService, private sendingSumAndPremiumInfo: SendingSumAndPremiumInfoService, private router: Router, private roleSendService: RoleSendService, private removeInfoService: RemoveInfoService, private saveDraftService: SaveDraftService, private sendInfoService: SendInfoService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )

    if (this.todayDate.getDate() > 25) {
      this.todayDate.setDate(1);
      this.todayDate.setMonth(this.todayDate.getMonth() + 2);
    } else {
      this.todayDate.setDate(1);
      this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    }

    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.basicInfoSubscription = basicInformationsService.info$.subscribe(
      (res: BasicInformations) => {
        // console.log(res.data.contractorType);
        this.basicInfo = res;
        if (res.data.contractorType == '1') {
          this.fatcaTypeBool = true;
          this.spnftForm.get('pib').setValue(res.data.contractorPIB);
          this.spnftForm.get('mb').setValue(res.data.contractorID);
          this.spnftForm.get('companyName').setValue(res.data.contractorResponsibleName);
        } else if (res.data.contractorType == '2') {
          this.fatcaTypeBool = false;
          this.spnftForm.get('pib').setValue('');
          this.spnftForm.get('mb').setValue('');
          this.spnftForm.get('companyName').setValue('');
        } else if (res.data.contractorType == '') {
          this.fatcaTypeBool = null;
        }

        // console.log(res.data)
        this.spnftForm.get('firstname').setValue(res.data.contractorFirstname);
        this.spnftForm.get('lastname').setValue(res.data.contractorLastname);
        this.spnftForm.get('jmbg').setValue(res.data.contractorJMBG);
        if (res.data.contractorJMBG) {
          if (res.data.contractorJMBG.length >= 7) {
            if (res.data.contractorJMBG.substring(4, 5) == '0') {
              this.spnftForm.get('dob').setValue(res.data.contractorJMBG.substring(0, 2) + "." + res.data.contractorJMBG.substring(2, 4) + '.2' + res.data.contractorJMBG.substring(4, 7))
            } else {
              this.spnftForm.get('dob').setValue(res.data.contractorJMBG.substring(0, 2) + "." + res.data.contractorJMBG.substring(2, 4) + '.1' + res.data.contractorJMBG.substring(4, 7))
            }
          }
        }
        if (res.data.insuredJMBG) {
          if (res.data.insuredJMBG.length >= 7) {
            if (res.data.insuredJMBG.substring(4, 5) == '0') {
              if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + res.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
                this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + res.data.insuredJMBG.substring(4, 7)))
                this.hideExport = false
              }
            } else {
              if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + res.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
                this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + res.data.insuredJMBG.substring(4, 7)))
                this.hideExport = false
              }
            }
          }
          // if (res.data.insuredJMBG.length >= 12) {
          //   if (parseInt(res.data.insuredJMBG.substring(9, 12)) < 500) {
          //     if (this.insuredSumAndPremiumForm.value.gender == 'Ž') {
          //       this.insuredSumAndPremiumForm.get('gender').setValue('M')
          //       this.hideExport = false
          //     }
          //   } else {
          //     if (this.insuredSumAndPremiumForm.value.gender == 'M') {
          //       this.insuredSumAndPremiumForm.get('gender').setValue('Ž')
          //       this.hideExport = false
          //     }
          //   }
          // }
        }
        this.spnftForm.get('address').setValue(res.data.contractorAddress);
        this.spnftForm.get('postalCode').setValue(res.data.contractorPostalCode);
        this.spnftForm.get('settlement').setValue(res.data.contractorSettlement);

        this.platimatikForm.get('firstname').setValue(res.data.contractorFirstname);
        this.platimatikForm.get('lastname').setValue(res.data.contractorLastname);
        this.platimatikForm.get('placeOfResidence').setValue(res.data.contractorSettlement);
        this.platimatikForm.get('address').setValue(res.data.contractorAddress);
        this.platimatikForm.get('postalCode').setValue(res.data.contractorPostalCode);
        this.platimatikForm.get('jmbg').setValue(res.data.contractorJMBG)

      }
    )
    this.sumAndPremiumInfoSubscription = sendingSumAndPremiumInfo.info$.subscribe(
      (res: InsuranceSumAndPremium) => {
        // console.log(res);
        if (res.data.insuranceStart)
          this.insuredSumAndPremiumForm.get('insuranceStart').setValue(res.data.insuranceStart);
        if (res.data.insurancePeriod) {
          this.insuredSumAndPremiumForm.get('insurancePeriod').setValue(res.data.insurancePeriod);
          let tempYear = this.todayDate.getFullYear();
          let tempMonth = this.todayDate.getMonth();
          let tempDay = this.todayDate.getDate();
          let tempDate = new Date(tempYear + parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value), tempMonth, tempDay);
          this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));
          this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value) + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
          this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value) + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
        }
        if (res.data.accessAge)
          this.insuredSumAndPremiumForm.get('accessAge').setValue(res.data.accessAge);
        if (res.data.gender)
          this.insuredSumAndPremiumForm.get('gender').setValue(res.data.gender);
        // if (res.data.occupation)
        //   this.insuredSumAndPremiumForm.get('occupation').setValue(res.data.occupation);
        if (res.data.dynamicsOfPayment)
          this.insuredSumAndPremiumForm.get('dynamicsOfPayment').setValue(res.data.dynamicsOfPayment);
        if (res.data.currencyPayment)
          this.insuredSumAndPremiumForm.get('currencyPayment').setValue(res.data.currencyPayment);
        if (res.data.currencyPayout)
          this.insuredSumAndPremiumForm.get('currencyPayout').setValue(res.data.currencyPayout);
        if (res.data.indexation)
          this.insuredSumAndPremiumForm.get('indexation').setValue(res.data.indexation);
        if (res.data.methodPayment)
          this.insuredSumAndPremiumForm.get('methodPayment').setValue(res.data.methodPayment)
      }
    )
  }

  ngOnInit() {
    this.getRoles();
    this.getUser()
    // this.getOccupation();
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'));
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
  }

  ngOnDestroy() {
    this.roleService.unsubscribe();
    this.basicInfoSubscription.unsubscribe();
    this.sumAndPremiumInfoSubscription.unsubscribe();
  }

  todayDate = new Date();
  changeDate(change: Boolean) {
    if (change) {
      this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    } else {
      this.todayDate.setMonth(this.todayDate.getMonth() - 1);
    }
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))

    if (this.basicInfo.data.insuredJMBG) {
      if (this.basicInfo.data.insuredJMBG.length >= 7) {
        if (this.basicInfo.data.insuredJMBG.substring(4, 5) == '0') {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        } else {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        }
      }
    }

    if (parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value)) {
      let tempYear = this.todayDate.getFullYear();
      let tempMonth = this.todayDate.getMonth();
      let tempDay = this.todayDate.getDate();
      let tempDate = new Date(tempYear + parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value), tempMonth, tempDay);
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));

      this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value) + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
      this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value) + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    }
  }
  endingDateSet() {
    if (this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout) {

      this.insuredSumAndPremiumForm.get('insurancePeriod').setValue(this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout + parseInt(this.insuredSumAndPremiumForm.get('scholarshipPeriodPayment').value))

      let tempYear = this.todayDate.getFullYear();
      let tempMonth = this.todayDate.getMonth();
      let tempDay = this.todayDate.getDate();
      let tempDate = new Date(tempYear + parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value), tempMonth, tempDay);
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));

      this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value) + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
      this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value) + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    } else {
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue('Trajanje osiguranja nije unet');
    }
    this.resetCalculation();
  }


  standardMessageDoctor: String;
  standardPlusMessageDoctor: String;
  standardProMessageDoctor: String;
  questionnarie: String = "Potrebno je popuniti finansijski upitnik.";
  hiv: String = "Potrebno je dostaviti rezultat testa na HIV."
  sendInformations() {
    if (this.insuredSumAndPremiumForm.value.accessAge && this.insuredSumAndPremiumForm.value.gender && this.insuredSumAndPremiumForm.value.dynamicsOfPayment && this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout && this.basicInfoForm.value.insuranceSum && (this.basicInfoForm.value.cigarettesDaily || this.basicInfoForm.value.cigarettesDaily == 0) && this.basicInfoForm.value.deathSuppInsurance && this.basicInfoForm.value.height && this.basicInfoForm.value.weight) {

      if (((this.personalForm.value.tbType == '' && this.personalForm.value.riderTB > 0) || (this.personalForm.value.tbType != '' && (this.personalForm.value.riderTB == '' || this.personalForm.value.riderTB == 0 || this.personalForm.value.riderTB == null))) && this.supplementaryIsnuranceHideAllBool && !this.supplementaryInsuranceBool) {
        this.errorTitle = "Niste uneli grupu težih bolesti ili niste odabrali iznos osigurane sume. Molimo Vas, proverite";
        this.modalService.open(this.alertModal, { centered: true })
      } else {

        let startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
        let endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];

        let scholershipPremium = new ScholarshipPremium({ StartTime: startDate, EndTime: endDate, HazardLevel: 2, Age: this.insuredSumAndPremiumForm.value.accessAge, Gender: this.insuredSumAndPremiumForm.value.gender, PaymentPeriodIn: this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout, PaymentPeriodOut: 0, PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment), Duration: parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value), SumInsured: this.basicInfoForm.value.insuranceSum, CigarettesPerDay: parseInt(this.basicInfoForm.value.cigarettesDaily), Height: parseInt(this.basicInfoForm.value.height), Weight: parseInt(this.basicInfoForm.value.weight) })

        if (this.basicInfoForm.value.deathSuppInsurance == '0') {
          scholershipPremium.data.AdditionalInsuranceDeath = false
        } else {
          scholershipPremium.data.AdditionalInsuranceDeath = true
        }

        scholershipPremium.data.AdditionalInsurance = this.supplementaryIsnuranceHideAllBool;

        if (!this.supplementaryInsuranceBool) {
          scholershipPremium.data.DeathByAccident = this.personalForm.value.deathByAccident;

          scholershipPremium.data.riderDeath = this.personalForm.value.riderDeath ? this.personalForm.value.riderDeath : 0;
          scholershipPremium.data.tbType = this.personalForm.value.tbType != '' ? Number(this.personalForm.value.tbType) : 0;
          scholershipPremium.data.riderTB = this.personalForm.value.riderTB ? this.personalForm.value.riderTB : 0;
          if (this.personalForm.value.includeDNA == '0') {
            scholershipPremium.data.IncludeDNA = false
          } else {
            scholershipPremium.data.IncludeDNA = true;
          }
          if (this.personalForm.value.includeMSO == '0') {
            scholershipPremium.data.IncludeMSO = false;
          } else {
            scholershipPremium.data.IncludeMSO = true;
          }

          if (this.personalForm.value.invalidityByAccident) {
            if (this.personalForm.value.surgery) {
              scholershipPremium.data.Surgery = this.personalForm.value.surgery;
            } else {
              scholershipPremium.data.Surgery = 0;
            }
            if (this.personalForm.value.monthlyRent) {
              scholershipPremium.data.MonthlyRent = this.personalForm.value.monthlyRent;
            } else {
              scholershipPremium.data.MonthlyRent = 0;
            }
            if (this.personalForm.value.daylyFee) {
              scholershipPremium.data.DailyFee = this.personalForm.value.daylyFee;
            } else {
              scholershipPremium.data.DailyFee = 0
            }
            if (this.personalForm.value.treatmanExpenses) {
              scholershipPremium.data.TreatmanExpenses = this.personalForm.value.treatmanExpenses;
            } else {
              scholershipPremium.data.TreatmanExpenses = 0;
            }
            scholershipPremium.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
          } else {
            scholershipPremium.data.InvalidityByAccident = 0;
            scholershipPremium.data.Surgery = 0;
            scholershipPremium.data.MonthlyRent = 0;
            scholershipPremium.data.DailyFee = 0;
            scholershipPremium.data.TreatmanExpenses = 0;
            scholershipPremium.data.IncludeMSO = false;
            scholershipPremium.data.IncludeDNA = false;
          }

        } else {
          scholershipPremium.data.DeathByAccident = 0;
          scholershipPremium.data.InvalidityByAccident = 0;
          scholershipPremium.data.Surgery = 0;
          scholershipPremium.data.MonthlyRent = 0;
          scholershipPremium.data.DailyFee = 0;
          scholershipPremium.data.TreatmanExpenses = 0;
          scholershipPremium.data.riderDeath = 0;
          scholershipPremium.data.tbType = 0;
          scholershipPremium.data.riderTB = 0;
          scholershipPremium.data.IncludeDNA = false;
          scholershipPremium.data.IncludeMSO = false;
          scholershipPremium.data.SelectedPackage = parseInt(this.insuranceCoverageForm.value.accidentPlan);
        }

        console.log(scholershipPremium);

        if (
          this.insuredSumAndPremiumForm.get('insurancePeriod').value < 5 ||
          this.insuredSumAndPremiumForm.get('insurancePeriod').value > 30 ||
          (this.insuredSumAndPremiumForm.get('insurancePeriod').value + this.insuredSumAndPremiumForm.value.accessAge) > 75 ||
          this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout < 1 ||
          this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout > 20 ||
          this.insuredSumAndPremiumForm.value.accessAge < 14 ||
          this.insuredSumAndPremiumForm.value.accessAge > 70 ||
          this.basicInfoForm.value.cigarettesDaily > 100
        ) {
          this.errorTitle = "Podaci nisu ispravni";
          this.modalService.open(this.alertModal, { centered: true })
          console.log("InValid")
        } else {
          if (!this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) {
            if (this.personalForm.value.deathByAccident) {
              if (
                this.personalForm.value.deathByAccident > 100000 ||
                (this.personalForm.value.surgery && (this.personalForm.value.surgery < 1000 || this.personalForm.value.surgery > 15000 || (this.personalForm.value.surgery > this.personalForm.value.deathByAccident * 2))) ||
                (this.personalForm.value.invalidityByAccident && (this.personalForm.value.invalidityByAccident < this.personalForm.value.deathByAccident || this.personalForm.value.invalidityByAccident > this.personalForm.value.deathByAccident * 2)) ||
                (this.personalForm.value.monthlyRent && (this.personalForm.value.monthlyRent < 100 || this.personalForm.value.monthlyRent > 600))
              ) {
                this.errorTitle = "Podaci nisu ispravni";
                this.modalService.open(this.alertModal, { centered: true })
              } else {
                this.basicInfoForm.get('premiumRate').setValue('')
                this.basicInfoForm.get('insuraceSumSupp').setValue('')
                this.basicInfoForm.get('premiumRateSupp').setValue('')
                this.insuranceCoverageForm.get('deathByAccident').setValue('')
                this.insuranceCoverageForm.get('invalidityByAccident').setValue('')
                this.insuranceCoverageForm.get('surgery').setValue('');
                this.insuranceCoverageForm.get('dailyFee').setValue('');
                this.insuranceCoverageForm.get('monthlyRent').setValue('')
                this.insuranceCoverageForm.get('premiumCoverageRateFirst').setValue('')
                this.insuranceCoverageForm.get('premiumCoverageRateSecond').setValue('')
                this.insuranceCoverageForm.get('premiumCoverageRateThird').setValue('')
                this.insuranceCoverageForm.get('premiumCoverageRateForth').setValue('')
                this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue('')
                this.insuranceCoverageForm.get('sumPremiumRateSecond').setValue('')
                this.insuranceCoverageForm.get('sumPremiumRateThird').setValue('')
                this.insuranceCoverageForm.get('sumPremiumRateForth').setValue('')
                this.insuranceCoverageForm.get('sumYearlyFirst').setValue('')
                this.insuranceCoverageForm.get('sumYearlySecond').setValue('')
                this.insuranceCoverageForm.get('sumYearlyThird').setValue('')
                this.insuranceCoverageForm.get('sumYearlyForth').setValue('')
                this.personalForm.get('additionalInsurance').setValue('')
                this.personalForm.get('sumPremiumRateFirst').setValue('')
                this.personalForm.get('sumYearlyFirst').setValue('')
                this.noCovrageForm.get('sumPremiumRateFirst').setValue('')
                this.noCovrageForm.get('sumYearlyFirst').setValue('')
                this.calculatorService.calculateScholarshipPremium(scholershipPremium)
                  .subscribe(
                    (x: any) => {
                      console.log(x);
                      this.hideExport = true;
                      this.sentInformations = x;

                      this.standardTableArray = x.standardTable;

                      this.standardMessageDoctor = ""
                      let calc = 0;
                      if (this.basicInfoForm.value.deathSuppInsurance == '1') {
                        calc = this.basicInfoForm.value.insuranceSum * 60 * 2;
                      } else {
                        calc = this.basicInfoForm.value.insuranceSum * 60;
                      }
                      if (this.insuredSumAndPremiumForm.value.accessAge <= 45) {
                        //Standard program
                        switch (true) {
                          case (calc <= 75000):
                            this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (calc <= 100000):
                            this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (calc <= 135000):
                            this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (calc > 135000):
                            this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }

                      } else if (this.insuredSumAndPremiumForm.value.accessAge >= 46 && this.insuredSumAndPremiumForm.value.accessAge <= 55) {

                        //Standard program
                        switch (true) {
                          case (calc <= 50000):
                            this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (calc <= 75000):
                            this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (calc <= 100000):
                            this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (calc > 100000):
                            this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }

                      } else {

                        //Standard program
                        switch (true) {
                          case (calc <= 30000):
                            this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                            break;
                          case (calc <= 50000):
                            this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                            break;
                          case (calc <= 75000):
                            this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                            break;
                          case (calc > 75000):
                            this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                            break;
                          default:
                            break;
                        }

                      }

                      //Popunjavanje forme za osigurani slucaj
                      this.basicInfoForm.get('premiumRate').setValue(x.premiumRate.toFixed(2))
                      this.basicInfoForm.get('insuraceSumSupp').setValue(x.additionalSumInsured.toFixed(2))
                      this.basicInfoForm.get('premiumRateSupp').setValue(x.additionalPremiumRate.toFixed(2))

                      // Popunjavanje forme dopunskog osiguranja
                      this.insuranceCoverageForm.get('deathByAccident').setValue(x.deathByAccident)
                      this.insuranceCoverageForm.get('invalidityByAccident').setValue(x.invalidityByAccident)
                      this.insuranceCoverageForm.get('surgery').setValue(x.surgery);
                      this.insuranceCoverageForm.get('dailyFee').setValue(x.dailyFee);
                      this.insuranceCoverageForm.get('monthlyRent').setValue(x.monthlyRent)

                      this.insuranceCoverageForm.get('premiumCoverageRateFirst').setValue(x.package1PremiumRate.toFixed(2))
                      this.insuranceCoverageForm.get('premiumCoverageRateSecond').setValue(x.package2PremiumRate.toFixed(2))
                      this.insuranceCoverageForm.get('premiumCoverageRateThird').setValue(x.package3PremiumRate.toFixed(2))
                      this.insuranceCoverageForm.get('premiumCoverageRateForth').setValue(x.package4PremiumRate.toFixed(2))

                      this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue(x.package1TotalPremiumRate.toFixed(2))
                      this.insuranceCoverageForm.get('sumPremiumRateSecond').setValue(x.package2TotalPremiumRate.toFixed(2))
                      this.insuranceCoverageForm.get('sumPremiumRateThird').setValue(x.package3TotalPremiumRate.toFixed(2))
                      this.insuranceCoverageForm.get('sumPremiumRateForth').setValue(x.package4TotalPremiumRate.toFixed(2))

                      this.insuranceCoverageForm.get('sumYearlyFirst').setValue(x.package1TotalPremiumRateYearly.toFixed(2))
                      this.insuranceCoverageForm.get('sumYearlySecond').setValue(x.package2TotalPremiumRateYearly.toFixed(2))
                      this.insuranceCoverageForm.get('sumYearlyThird').setValue(x.package3TotalPremiumRateYearly.toFixed(2))
                      this.insuranceCoverageForm.get('sumYearlyForth').setValue(x.package4TotalPremiumRateYearly.toFixed(2))

                      // Popunjavanje personalizovane forme
                      this.personalForm.get('additionalInsurance').setValue(x.personalizedPremiumRate.toFixed(2))
                      this.personalForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate.toFixed(2))
                      this.personalForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly.toFixed(2))

                      this.noCovrageForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate)
                      this.noCovrageForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly)

                    },
                    (x: { error: String }) => {
                      console.log(x)
                      this.errorTitle = x.error;
                      this.modalService.open(this.alertModal, { centered: true })
                    }
                  )
              }
            } else {
              this.errorTitle = "Niste uneli sve tražene podatke";
              this.modalService.open(this.alertModal, { centered: true })
            }
          } else {
            this.basicInfoForm.get('premiumRate').setValue('')
            this.basicInfoForm.get('insuraceSumSupp').setValue('')
            this.basicInfoForm.get('premiumRateSupp').setValue('')
            this.insuranceCoverageForm.get('deathByAccident').setValue('')
            this.insuranceCoverageForm.get('invalidityByAccident').setValue('')
            this.insuranceCoverageForm.get('surgery').setValue('');
            this.insuranceCoverageForm.get('dailyFee').setValue('');
            this.insuranceCoverageForm.get('monthlyRent').setValue('')
            this.insuranceCoverageForm.get('premiumCoverageRateFirst').setValue('')
            this.insuranceCoverageForm.get('premiumCoverageRateSecond').setValue('')
            this.insuranceCoverageForm.get('premiumCoverageRateThird').setValue('')
            this.insuranceCoverageForm.get('premiumCoverageRateForth').setValue('')
            this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue('')
            this.insuranceCoverageForm.get('sumPremiumRateSecond').setValue('')
            this.insuranceCoverageForm.get('sumPremiumRateThird').setValue('')
            this.insuranceCoverageForm.get('sumPremiumRateForth').setValue('')
            this.insuranceCoverageForm.get('sumYearlyFirst').setValue('')
            this.insuranceCoverageForm.get('sumYearlySecond').setValue('')
            this.insuranceCoverageForm.get('sumYearlyThird').setValue('')
            this.insuranceCoverageForm.get('sumYearlyForth').setValue('')
            this.personalForm.get('additionalInsurance').setValue('')
            this.personalForm.get('sumPremiumRateFirst').setValue('')
            this.personalForm.get('sumYearlyFirst').setValue('')
            this.noCovrageForm.get('sumPremiumRateFirst').setValue('')
            this.noCovrageForm.get('sumYearlyFirst').setValue('')
            this.calculatorService.calculateScholarshipPremium(scholershipPremium)
              .subscribe(
                (x: any) => {
                  console.log(x);
                  this.hideExport = true;
                  this.sentInformations = x;

                  this.standardTableArray = x.standardTable;

                  this.standardMessageDoctor = ""
                  let calc = 0;
                  if (this.basicInfoForm.value.deathSuppInsurance == '1') {
                    calc = this.basicInfoForm.value.insuranceSum * 60 * 2;
                  } else {
                    calc = this.basicInfoForm.value.insuranceSum * 60;
                  }
                  if (this.insuredSumAndPremiumForm.value.accessAge <= 45) {
                    //Standard program
                    switch (true) {
                      case (calc <= 75000):
                        this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (calc <= 100000):
                        this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (calc <= 135000):
                        this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (calc > 135000):
                        this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }

                  } else if (this.insuredSumAndPremiumForm.value.accessAge >= 46 && this.insuredSumAndPremiumForm.value.accessAge <= 55) {

                    //Standard program
                    switch (true) {
                      case (calc <= 50000):
                        this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (calc <= 75000):
                        this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (calc <= 100000):
                        this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (calc > 100000):
                        this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }

                  } else {

                    //Standard program
                    switch (true) {
                      case (calc <= 30000):
                        this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                        break;
                      case (calc <= 50000):
                        this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                        break;
                      case (calc <= 75000):
                        this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                        break;
                      case (calc > 75000):
                        this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                        break;
                      default:
                        break;
                    }

                  }

                  //Popunjavanje forme za osigurani slucaj
                  this.basicInfoForm.get('premiumRate').setValue(x.premiumRate.toFixed(2))
                  this.basicInfoForm.get('insuraceSumSupp').setValue(x.additionalSumInsured.toFixed(2))
                  this.basicInfoForm.get('premiumRateSupp').setValue(x.additionalPremiumRate.toFixed(2))

                  // Popunjavanje forme dopunskog osiguranja
                  this.insuranceCoverageForm.get('deathByAccident').setValue(x.deathByAccident)
                  this.insuranceCoverageForm.get('invalidityByAccident').setValue(x.invalidityByAccident)
                  this.insuranceCoverageForm.get('surgery').setValue(x.surgery);
                  this.insuranceCoverageForm.get('dailyFee').setValue(x.dailyFee);
                  this.insuranceCoverageForm.get('monthlyRent').setValue(x.monthlyRent)

                  this.insuranceCoverageForm.get('premiumCoverageRateFirst').setValue(x.package1PremiumRate.toFixed(2))
                  this.insuranceCoverageForm.get('premiumCoverageRateSecond').setValue(x.package2PremiumRate.toFixed(2))
                  this.insuranceCoverageForm.get('premiumCoverageRateThird').setValue(x.package3PremiumRate.toFixed(2))
                  this.insuranceCoverageForm.get('premiumCoverageRateForth').setValue(x.package4PremiumRate.toFixed(2))

                  this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue(x.package1TotalPremiumRate.toFixed(2))
                  this.insuranceCoverageForm.get('sumPremiumRateSecond').setValue(x.package2TotalPremiumRate.toFixed(2))
                  this.insuranceCoverageForm.get('sumPremiumRateThird').setValue(x.package3TotalPremiumRate.toFixed(2))
                  this.insuranceCoverageForm.get('sumPremiumRateForth').setValue(x.package4TotalPremiumRate.toFixed(2))

                  this.insuranceCoverageForm.get('sumYearlyFirst').setValue(x.package1TotalPremiumRateYearly.toFixed(2))
                  this.insuranceCoverageForm.get('sumYearlySecond').setValue(x.package2TotalPremiumRateYearly.toFixed(2))
                  this.insuranceCoverageForm.get('sumYearlyThird').setValue(x.package3TotalPremiumRateYearly.toFixed(2))
                  this.insuranceCoverageForm.get('sumYearlyForth').setValue(x.package4TotalPremiumRateYearly.toFixed(2))

                  // Popunjavanje personalizovane forme
                  this.personalForm.get('additionalInsurance').setValue(x.personalizedPremiumRate.toFixed(2))
                  this.personalForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate.toFixed(2))
                  this.personalForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly.toFixed(2))

                  this.noCovrageForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate)
                  this.noCovrageForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly)

                },
                (x: { error: String }) => {
                  console.log(x)
                  this.errorTitle = x.error;
                  this.modalService.open(this.alertModal, { centered: true })
                }
              )
          }
        }
      }

    } else {
      this.errorTitle = "Niste uneli sve tražene podatke";
      this.modalService.open(this.alertModal, { centered: true })

    }

  }

  exportpft() {
    let startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
    let endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];
    let exportpdf = new ScholershipPremiumExport({
      ContratcorType: this.basicInfo.data.contractorType == '1' ? '1' : '0',
      CompanyName: this.basicInfo.data.contractorResponsibleName,
      Firstname: this.basicInfo.data.contractorFirstname,
      Lastname: this.basicInfo.data.contractorLastname,
      JMBG: this.basicInfo.data.contractorJMBG,
      Email: this.basicInfo.data.contractorEmail,
      TaxID: this.basicInfo.data.contractorPIB,
      CompanyID: this.basicInfo.data.contractorID,
      Address: this.basicInfo.data.contractorAddress,
      Settlement: this.basicInfo.data.contractorSettlement,
      PostalCode: this.basicInfo.data.contractorPostalCode,
      ContactPhone: this.basicInfo.data.contractorPhonenumber,
      DeliveryAddress: this.basicInfo.data.contractorAddressOfDelivery,
      InsureeFirstname: this.basicInfo.data.insuredFirstname,
      InsureeLastname: this.basicInfo.data.insuredLastname,
      InsureeAddress: this.basicInfo.data.insuredAddress,
      InsureeSettlement: this.basicInfo.data.insuredSettlement,
      InsureePostalCode: this.basicInfo.data.insuredPostalCode,
      InsureeJMBG: this.basicInfo.data.insuredJMBG,
      InsureeContactPhone1: this.basicInfo.data.insuredMobile,
      InsureeContactPhone2: '',
      InsureeOccupation: this.basicInfo.data.insuredJob,
      StartTime: startDate,
      EndTime: endDate,
      Duration: 5 + parseInt(this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout),
      Age: this.insuredSumAndPremiumForm.value.accessAge,
      Gender: this.insuredSumAndPremiumForm.value.gender,
      HazardLevel: 2,
      CigarettesPerDay: this.basicInfoForm.value.cigarettesDaily,
      PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
      Height: this.basicInfoForm.value.height,
      Weight: this.basicInfoForm.value.weight,
      PremiumRate: this.sentInformations.premiumRate,
      Offer: this.checkBoxesForm.value.offer,
      RedemptionAndCapitalization: this.checkBoxesForm.value.redemptionAndCapitalization,
      ProContract: this.checkBoxesForm.value.proContract,
      Terms: this.checkBoxesForm.value.terms,
      SumInsured: this.basicInfoForm.value.insuranceSum,
      AdditionalInsurance: this.supplementaryIsnuranceHideAllBool,
      AdditionalDocumentation: this.checkBoxesForm.value.doctor,
      PaymentPeriodOut: 5,
      PaymentPeriodIn: parseInt(this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout),
      GrantTable: this.sentInformations.standardTable,
      AdditionalSumInsured: this.sentInformations.additionalSumInsured,
      AdditionalInsuranceDeathPremiumRate: this.sentInformations.additionalPremiumRate
    });
    if (this.basicInfo.data.insuredDOB) {
      exportpdf.data.InsureeDOB = this.basicInfo.data.insuredDOB;
    } else {
      exportpdf.data.InsureeDOB = '';
    }
    if (this.basicInfoForm.value.deathSuppInsurance == '0') {
      exportpdf.data.AdditionalInsuranceDeath = false;
    } else if (this.basicInfoForm.value.deathSuppInsurance == '1') {
      exportpdf.data.AdditionalInsuranceDeath = true;
    }
    if (!this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) {
      console.log("Personal")
      exportpdf.data.DeathByAccident = this.personalForm.value.deathByAccident;
      exportpdf.data.SelectedPackage = 0;
      exportpdf.data.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;

      exportpdf.data.riderDeath = this.personalForm.value.riderDeath ? Number(this.personalForm.value.riderDeath) : 0;
      exportpdf.data.tbType = Number(this.personalForm.value.tbType);
      exportpdf.data.riderTB = this.personalForm.value.riderTB ? Number(this.personalForm.value.riderTB) : 0;
      if (this.personalForm.value.includeMSO == '0') {
        exportpdf.data.IncludeMSO = false;
      } else {
        exportpdf.data.IncludeMSO = true;
      }
      if (this.personalForm.value.includeDNA == '0') {
        exportpdf.data.IncludeDNA = false;
      } else {
        exportpdf.data.IncludeDNA = true;
      }
      if (this.personalForm.value.invalidityByAccident) {
        if (this.personalForm.value.surgery) {
          exportpdf.data.Surgery = this.personalForm.value.surgery;
        } else {
          exportpdf.data.Surgery = 0;
        }
        if (this.personalForm.value.monthlyRent) {
          exportpdf.data.MonthlyRent = this.personalForm.value.monthlyRent;
        } else {
          exportpdf.data.MonthlyRent = 0;
        }
        if (this.personalForm.value.daylyFee) {
          exportpdf.data.DailyFee = this.personalForm.value.daylyFee;
        } else {
          exportpdf.data.DailyFee = 0
        }
        if (this.personalForm.value.treatmanExpenses) {
          exportpdf.data.TreatmanExpenses = this.personalForm.value.treatmanExpenses;
        } else {
          exportpdf.data.TreatmanExpenses = 0;
        }
        exportpdf.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
      } else {
        exportpdf.data.InvalidityByAccident = 0;
        exportpdf.data.Surgery = 0;
        exportpdf.data.MonthlyRent = 0;
        exportpdf.data.DailyFee = 0;
        exportpdf.data.TreatmanExpenses = 0;
        exportpdf.data.IncludeMSO = false;
        exportpdf.data.IncludeDNA = false;
      }
      exportpdf.data.TotalPremiumRate = this.sentInformations.totalPremiumRate
      exportpdf.data.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly
    } else if (this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) {
      console.log("Dopunsko")
      exportpdf.data.SelectedPackage = parseInt(this.insuranceCoverageForm.value.accidentPlan);
      exportpdf.data.DeathByAccident = this.sentInformations.deathByAccident;
      exportpdf.data.InvalidityByAccident = this.sentInformations.invalidityByAccident;
      exportpdf.data.MonthlyRent = this.sentInformations.monthlyRent;
      exportpdf.data.TreatmanExpenses = 0;
      exportpdf.data.DailyFee = 0;
      exportpdf.data.riderDeath = 0;
      exportpdf.data.tbType = 0;
      exportpdf.data.riderTB = 0;
      switch (this.insuranceCoverageForm.value.accidentPlan) {
        case '1':
          exportpdf.data.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
          exportpdf.data.TotalPremiumRate = this.sentInformations.package1TotalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.package1TotalPremiumRateYearly
          exportpdf.data.Surgery = 0;
          exportpdf.data.IncludeMSO = false;
          exportpdf.data.IncludeDNA = false;
          break;
        case '2':
          exportpdf.data.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
          exportpdf.data.TotalPremiumRate = this.sentInformations.package2TotalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.package2TotalPremiumRateYearly
          exportpdf.data.Surgery = this.sentInformations.surgery;
          exportpdf.data.IncludeMSO = true;
          exportpdf.data.IncludeDNA = false;
          break;
        case '3':
          exportpdf.data.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
          exportpdf.data.TotalPremiumRate = this.sentInformations.package3TotalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.package3TotalPremiumRateYearly
          exportpdf.data.Surgery = this.sentInformations.surgery;
          exportpdf.data.DailyFee = this.sentInformations.dailyFee;
          exportpdf.data.IncludeMSO = false;
          exportpdf.data.IncludeDNA = false;
          break;
        case '4':
          exportpdf.data.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
          exportpdf.data.TotalPremiumRate = this.sentInformations.package4TotalPremiumRate;
          exportpdf.data.TotalPremiumRateYearly = this.sentInformations.package4TotalPremiumRateYearly
          exportpdf.data.Surgery = 0;
          exportpdf.data.IncludeMSO = true;
          exportpdf.data.IncludeDNA = true;
          break;
        default:
          break;
      }
    } else {
      exportpdf.data.SelectedPackage = 0;
      exportpdf.data.DeathByAccident = 0;
      exportpdf.data.InvalidityByAccident = 0;
      exportpdf.data.Surgery = 0;
      exportpdf.data.TreatmanExpenses = 0;
      exportpdf.data.DailyFee = 0;
      exportpdf.data.MonthlyRent = 0;
      exportpdf.data.riderDeath = 0;
      exportpdf.data.tbType = 0;
      exportpdf.data.riderTB = 0;
      exportpdf.data.IncludeMSO = false;
      exportpdf.data.IncludeDNA = true;
      exportpdf.data.AdditionalPremiumRate = 0;
      exportpdf.data.TotalPremiumRate = this.sentInformations.totalPremiumRate;
      exportpdf.data.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
    }
    console.log(exportpdf)
    this.exportService.exportScholarshipPremium(exportpdf)
      .subscribe(
        x => {
          console.log(x);
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1].split('"')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      )
  }

  resetAllForms() {
    this.insuredSumAndPremiumForm.reset({ currencyPayment: '0', currencyPayout: '0', scholarshipPeriodPayment: '5' })
    this.todayDate = new Date()
    this.todayDate.setDate(1);
    this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.basicInfoForm.reset();
    this.healthForm.reset({ agreeToHealthQuestionnaire: true })
    this.fatcaForm.reset({
      citizenshipSad: '1',
      texpayerSad: '1',
      insuredLegalEntitySad: '1',
      insuredTaxpayerSad: '1',
      insuredTenPrecentShare: '1',
      insuredFinancialInstitution: '1'
    })
    this.standardTableArray = []
    this.spnftForm.reset({ officialCloseFamily: '0' })
    this.sendInfoService.sendInfo(true)
    this.platimatikForm.reset()
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.hideExport = false;
    this.insuranceCoverageForm.reset({ accidentPlan: '3', planRadio: '2' })
    this.personalForm.reset({ includeMSO: '0', includeDNA: '0', planRadio: '2' })
    this.noCovrageForm.reset({ planRadio: '2' })
    this.checkBoxesForm.reset({ confirmVeracity: false, confirmData: false, confirmSMS: '1', confirmEmail: '1', offer: true, redemptionAndCapitalization: false, proContract: false, terms: false, doctor: false })
    this.insuranceUsers = []
    this.validInsuranceAndSumPremium = false;
    this.validUser = false;
    this.validSPNFT = true;
    this.validPLATIMATIK = false;
    this.calculcatorUsersBool = false;
    this.healthQuestionnaireBool = false;
    this.noticePersonalityBool = false;
    this.noticeFatcaBool = false;
    this.formSpnftBool = false;
    // this.basicInfo = new BasicInformations({});
  }

  addInsuranceUser() {
    let num = 0;
    for (let i = 0; i < this.insuranceUsers.length; i++) {
      if (parseInt(this.insuranceUserForm.value.role.split('-')[0]) == this.insuranceUsers[i].RoleID) {
        num++;
      }
    }
    if (parseInt(this.insuranceUserForm.value.role.split('-')[2]) == 0) {
      if (num >= 1) {
        this.errorTitle = "Ne mozete uneti više korisnika sa tom rolom";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.insuranceUsers.push(new Beneficiaries(0, this.insuranceUserForm.value.name.toUpperCase(), this.insuranceUserForm.value.jmbg, this.insuranceUserForm.value.remark, parseInt(this.insuranceUserForm.value.role.split('-')[0]), this.insuranceUserForm.value.role.split('-')[1], 0))
      }
    } else {
      if (num >= parseInt(this.insuranceUserForm.value.role.split('-')[2])) {
        this.errorTitle = "Ne mozete uneti više korisnika sa tom rolom";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.insuranceUsers.push(new Beneficiaries(0, this.insuranceUserForm.value.name.toUpperCase(), this.insuranceUserForm.value.jmbg, this.insuranceUserForm.value.remark, parseInt(this.insuranceUserForm.value.role.split('-')[0]), this.insuranceUserForm.value.role.split('-')[1], 0))
      }
    }
    this.insuranceUserForm.reset();
  }
  removeFromList(i) {
    this.insuranceUsers.splice(i, 1);
  }

  disabledPersonal() {
    if (this.personalForm.value.invalidityByAccident) {
      this.personalForm.controls['surgery'].enable();
      this.personalForm.controls['monthlyRent'].enable();
      this.personalForm.controls['treatmanExpenses'].enable();
      this.personalForm.controls['daylyFee'].enable();
      this.personalForm.controls['includeDNA'].enable();
      this.personalForm.controls['includeMSO'].enable();
    } else {
      this.personalForm.controls['surgery'].disable();
      this.personalForm.controls['monthlyRent'].disable();
      this.personalForm.controls['treatmanExpenses'].disable();
      this.personalForm.controls['daylyFee'].disable();
      this.personalForm.controls['includeDNA'].disable();
      this.personalForm.controls['includeMSO'].disable();
    }
  }

  accountNumberSetBank() {
    if (this.platimatikForm.value.firstThreeAccountNumber.length == 3) {
      this.bankService.gridView(new Filter({ Top: null, Page: null, Filter: {}, Sort: {} }))
        .subscribe(
          (res: Array<{ code: String, name: String, swift: String }>) => {
            for (let i = 0; i < res.length; i++) {
              if (res[i].code == this.platimatikForm.value.firstThreeAccountNumber) {
                this.platimatikForm.get('bankName').setValue(res[i].name);
                this.platimatikForm.get('bankBic').setValue(res[i].swift);
                this.accNumber.nativeElement.focus();
                break;
              }
            }
          }
        )
    } else if (this.platimatikForm.value.firstThreeAccountNumber.length < 3) {
      this.platimatikForm.get('bankName').setValue('');
      this.platimatikForm.get('bankBic').setValue('');
    }
  }

  checkAccount() {
    if (this.platimatikForm.value.middleAccountNumber.length <= 13) {
      this.platimatikForm.get('middleAccountNumber').setValue('0'.repeat(13 - this.platimatikForm.value.middleAccountNumber.length) + this.platimatikForm.value.middleAccountNumber)
    }
  }

  signOnSpot() {
    // console.log(this.offerId);
    this.offerService.createDigitalOffer(this.offerModelFull)
      .then(
        (x: any) => {
          console.log(x);
          this.offerId = x;
          this.offerService.sendLocalDocuments(this.offerId)
            .then(
              x => {
                this.modalService.dismissAll();
                this.resetAllForms()
                this.insuranceUsers = []
                this.formPlatimatikBool = false;
                this.formSpnftBool = false;
                this.noticeFatcaBool = false;
                this.healthQuestionnaireBool = false;
                this.calculcatorUsersBool = false;
                this.validInsuranceAndSumPremium = false;
                this.validUser = false;
                this.validSPNFT = false;
                this.validPLATIMATIK = false;
                this.router.navigate(['/sign-documents-on-spot/' + this.offerId]);
                // this.router.navigate([]).then(r => { window.open('/sign-documents-on-spot/' + this.offerId, '_blank') })
              }
            )
        },
        (x: any) => {
          console.log(x)
          this.errorTitle = x.error;
          this.modalService.open(this.alertModal, { centered: true })
        }
      )
  }

  setTBRole() {
    let index = this.roles.findIndex(x => x.productRoleID == 3) // 3 za produkciju 8 za test
    if (this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != null && this.personalForm.value.riderTB != 0 && !this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) {
      if (index == -1) {
        this.roles.push({
          allowMultipleClients: false,
          maxClientsPerRole: 0,
          productRole: {
            createdBy: null,
            createdByID: 1,
            createdOn: "2020-06-08T12:54:32.007",
            id: 3, //3 za produkciju 8 za test
            lastModifiedBy: null,
            lastModifiedByID: null,
            lastModifiedOn: null,
            name: "U slučaju teže bolesti",
            productTypesRoles: []
          },
          productRoleID: 3, //3 za produkciju 8 za test
          productType: 2
        })
      }
    } else {
      if (index != -1) {
        this.roles.splice(index, 1)
      }
    }
  }

  openSignOnDistanceModal(modal) {
    this.modalService.open(modal, { size: 'lg', backdrop: 'static', keyboard: false })
  }
  openSignOnSiteModal(modal) {
    this.modalService.open(modal, { size: 'lg', backdrop: 'static', keyboard: false })
  }
  blockSendingBool: boolean = true
  openRiskModal(modal) {
    this.blockSendingBool = false
    this.offerService.createDigitalOffer(this.offerModelFull)
      .then(
        (x: any) => {
          console.log(x);
          this.blockSendingBool = true
          this.offerId = x;
          this.riskAssessmentForm.reset();
          this.modalService.open(modal, { size: 'xl', backdrop: 'static', keyboard: false })
          if (this.spnftForm.value.officialCloseFamily == '1') {
            this.riskAssessmentForm.get('question11').setValue('0');
            this.riskAssessmentForm.get('question11').disable();
          } else {
            this.riskAssessmentForm.get('question11').enable();
          }
        },
        (x: any) => {
          console.log(x)
          this.errorTitle = x.error;
          this.modalService.open(this.alertModal, { centered: true })
        }
      )
  }
  addRiskAssessment() {
    if (this.riskAssessmentForm.valid) {
      let risk = new RiskAssessment({
        OfferID: this.offerId,
        Q1: this.riskAssessmentForm.value.question1 == '0' ? true : false,
        Q2: this.riskAssessmentForm.value.question2 == '0' ? true : false,
        Q3: this.riskAssessmentForm.value.question3 == '0' ? true : false,
        Q4: this.riskAssessmentForm.value.question4 == '0' ? true : false,
        Q5: this.riskAssessmentForm.value.question5 == '0' ? true : false,
        Q6: this.riskAssessmentForm.value.question6 == '0' ? true : false,
        Q7: this.riskAssessmentForm.value.question7 == '0' ? true : false,
        Q8: this.riskAssessmentForm.value.question8 == '0' ? true : false,
        Q9: this.riskAssessmentForm.value.question9 == '0' ? true : false,
        Q10: this.riskAssessmentForm.value.question10 == '0' ? true : false,
        Q11: this.riskAssessmentForm.get('question11').value == '0' ? true : false,
        Q12: this.riskAssessmentForm.value.question12 == '0' ? true : false,
        Q13: this.riskAssessmentForm.value.question13 == '0' ? true : false,
        Q14: this.riskAssessmentForm.value.question14 == '0' ? true : false,
        Q15: this.riskAssessmentForm.value.question15 == '0' ? true : false,
        Q16: this.riskAssessmentForm.value.question16 == '0' ? true : false,
        Q17: this.riskAssessmentForm.value.question17 == '0' ? true : false,
        Q18: this.riskAssessmentForm.value.question18 == '0' ? true : false,
        Q19: this.riskAssessmentForm.value.question19 == '0' ? true : false,
        Q20: this.riskAssessmentForm.value.question20 == '0' ? true : false,
        Q21: this.riskAssessmentForm.value.question21 == '0' ? true : false,
        Q22: this.riskAssessmentForm.value.question22 == '0' ? true : false,
        Q23: this.riskAssessmentForm.value.question23 == '0' ? true : false,
        Q24: this.riskAssessmentForm.value.question24 == '0' ? true : false,
        Q25: this.riskAssessmentForm.value.question25 == '0' ? true : false,
        Q26: this.riskAssessmentForm.value.question26 == '0' ? true : false,
        Q27: this.riskAssessmentForm.value.question27 == '0' ? true : false,
        Q28: this.riskAssessmentForm.value.question28 == '0' ? true : false,
        Q29: this.riskAssessmentForm.value.question29 == '0' ? true : false,
        UnableToGetData: false
      })
      this.offerService.createRiskAssessment(risk)
        .then(
          x => {
            // this.modalService.dismissAll();
            this.signDistance();
            // this.modalService.open(modal, { size: 'lg', backdrop: 'static', keyboard: false })
          }
        )
    } else {
      // console.log("now checked wverything")
      this.errorTitle = "Niste odgovorili na sva pitanja";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }
  signDistance() {
    console.log(this.offerId);
    this.offerService.sentSignRequest(this.offerId)
      .then(
        x => {
          console.log(x);
          this.successTitle = "Uspešno ste kreirali digitalnu ponudu";
          this.modalService.dismissAll();
          this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
          this.resetAllForms()
          this.insuranceUsers = []
          this.formPlatimatikBool = false;
          this.formSpnftBool = false;
          this.noticeFatcaBool = false;
          this.healthQuestionnaireBool = false;
          this.calculcatorUsersBool = false;
          this.validInsuranceAndSumPremium = false;
          this.validUser = false;
          this.validSPNFT = false;
          this.validPLATIMATIK = false;
          this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
        }
      )
  }

  draftModelFull: StandardOSOffer;
  saveDraft() {
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname) {
        this.saveDraftService.addInfo();
        console.log("Nije uneto ime i prezime")
      } else {
        if (
          ((this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.accidentPlan == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.accidentPlan == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.accidentPlan == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.accidentPlan == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (!this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
        ) {
          this.errorTitle = "Ne možete napraviti digitalnu ponudu ukoliko godisnja premija nije manja od 1500 €";
          this.modalService.open(this.alertModal, { centered: true })
        } else {

          let startDate = '';
          let endDate = '';
          if (this.insuredSumAndPremiumForm.get('insuranceStart').value) {
            startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
          } else {
            startDate = ''
          }
          if (this.insuredSumAndPremiumForm.get('insuranceEnd').value) {
            endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];
          } else {
            endDate = ''
          }

          this.draftModelFull = new StandardOSOffer({
            InsuranceStart: startDate,
            InsuranceEnd: endDate,
            OfferNumber: "",
            OfferType: 1,
            ContractorID: 0,
            InsureeID: 0,
            OneTimePayment: false,
            PaymentPeriodMonths: 0,
            Interest: 0,
            CreditAmount: 0,
            AdditionalIL: false,
            AdditionalBF: false,
            AdditionalAS: false,
            Contractor: new OfferClient(
              this.basicInfo.data.contractorType == '1' ? '1' : '0',
              this.basicInfo.data.contractorFirstname,
              this.basicInfo.data.contractorLastname,
              this.basicInfo.data.contractorResponsibleName ? this.basicInfo.data.contractorResponsibleName : '',
              this.basicInfo.data.contractorJMBG ? this.basicInfo.data.contractorJMBG : '',
              this.basicInfo.data.contractorPhonenumber ? this.basicInfo.data.contractorPhonenumber : '',
              this.basicInfo.data.contractorEmail ? this.basicInfo.data.contractorEmail : '',
              this.basicInfo.data.contractorAddress ? this.basicInfo.data.contractorAddress : '',
              this.basicInfo.data.contractorSettlement ? this.basicInfo.data.contractorSettlement : '',
              this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode.toString() : "",
              this.basicInfo.data.contractorAddressOfDelivery ? this.basicInfo.data.contractorAddressOfDelivery : '',
              this.basicInfo.data.contractorSettlementOfDelivery ? this.basicInfo.data.contractorSettlementOfDelivery : '',
              this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery.toString() : "",
              0,
              "",
              "",
              0
            ),
            Insuree: new OfferInsuree(
              this.basicInfo.data.insuredFirstname ? this.basicInfo.data.insuredFirstname : '',
              this.basicInfo.data.insuredLastname ? this.basicInfo.data.insuredLastname : '',
              this.basicInfo.data.insuredJMBG ? this.basicInfo.data.insuredJMBG : '',
              this.basicInfo.data.insuredDOB ? this.basicInfo.data.insuredDOB : '',
              this.basicInfo.data.insuredMobile ? this.basicInfo.data.insuredMobile : '',
              this.basicInfo.data.insuredEmail ? this.basicInfo.data.insuredEmail : '',
              this.basicInfo.data.insuredAddress ? this.basicInfo.data.insuredAddress : '',
              this.basicInfo.data.insuredSettlement ? this.basicInfo.data.insuredSettlement : '',
              this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode.toString() : "",
              this.basicInfo.data.insuredJob ? this.basicInfo.data.insuredJob : '',
              0,
              0,
              0
            ),
            Gender: this.insuredSumAndPremiumForm.value.gender,
            ContractorIsInsuree: this.basicInfo.data.contractorCopy,
            HazardLevel: 2,
            CigarettesPerDay: parseInt(this.basicInfoForm.value.cigarettesDaily),
            Height: parseInt(this.basicInfoForm.value.height),
            Weight: this.basicInfoForm.value.weight,
            AdditionalInsuranceDeath: this.basicInfoForm.value.deathSuppInsurance == '0' ? false : true,
            PaymentPeriodOut: 5,
            PaymentPeriodIn: this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout,
            StartingAge: this.insuredSumAndPremiumForm.value.accessAge,
            Duration: parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value),
            SumInsured: this.basicInfoForm.value.insuranceSum,
            PaymentPeriod: 0,
            RentPaymentFrequency: 0,
            RentPayment: 0,
            PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
            PaymentType: parseInt(this.insuredSumAndPremiumForm.value.methodPayment),
            ProductType: 7,
            ClientStatusID: null,
            PaymentInCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayment),
            PaymentOutCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayout),
            Comment: "",
            UserID: this.userId,
            NotificationsAgreement: this.checkBoxesForm.value.confirmSMS == '1' ? true : false,
            Verified: this.checkBoxesForm.value.confirmVeracity,
            Verified2: this.checkBoxesForm.value.confirmVeracity,
            Verified3: this.checkBoxesForm.value.confirmEmail == '1' ? true : false,
            RedemptionAndCapitalization: new RedemptionAndCapitalizations(),
            Indexation: this.insuredSumAndPremiumForm.value.indexation == '' ? null : this.insuredSumAndPremiumForm.value.indexation == '0' ? false : true,
            Beneficiaries: this.insuranceUsers.length > 0 ? this.insuranceUsers : null,
            HealthQuestionnaire: new HealthQuestionnaire(
              0,
              this.healthForm.value.threeMonthStayAbroad == '' ? null : this.healthForm.value.threeMonthStayAbroad == '0' ? true : false,
              this.healthForm.value.threeMonthStayAbroad == '0' ? this.healthForm.value.threeMonthStayAbroadDescription : '',
              this.healthForm.value.deniedAcceptedRequest == '' ? null : this.healthForm.value.deniedAcceptedRequest == '0' ? true : false,
              this.healthForm.value.deniedAcceptedRequest == '0' ? this.healthForm.value.deniedacceptedRequestDescription : '',
              this.healthForm.value.sportActivity == '' ? null : this.healthForm.value.sportActivity == '0' ? true : false,
              this.healthForm.value.sportActivity == '0' ? this.healthForm.value.sportActivityDescription : '',
              this.healthForm.value.constantDoctorTreats == '' ? null : this.healthForm.value.constantDoctorTreats == '0' ? true : false,
              this.healthForm.value.constantDoctorTreats == '0' ? this.healthForm.value.constantDoctorTreatsDescription : '',
              this.healthForm.value.specialMedicalExamination == '' ? null : this.healthForm.value.specialMedicalExamination == '0' ? true : false,
              this.healthForm.value.specialMedicalExamination == '0' ? this.healthForm.value.specialMedicalExaminationDescription : '',
              this.healthForm.value.takingMedicines == '' ? null : this.healthForm.value.takingMedicines == '0' ? true : false,
              this.healthForm.value.takingMedicines == '0' ? this.healthForm.value.takingMedicinesDescription : '',
              this.healthForm.value.alcoholOrIntoxicants == '' ? null : this.healthForm.value.alcoholOrIntoxicants == '0' ? true : false,
              this.healthForm.value.alcoholOrIntoxicants == '0' ? this.healthForm.value.alcoholOrIntoxicantsDescription : '',
              this.healthForm.value.helpForAlcoholAddiction == '' ? null : this.healthForm.value.helpForAlcoholAddiction == '0' ? true : false,
              this.healthForm.value.helpForAlcoholAddiction == '0' ? this.healthForm.value.helpForAlcoholAddictionDescription : '',
              this.healthForm.value.consumeCigarettes == '' ? null : this.healthForm.value.consumeCigarettes == '0' ? true : false,
              this.healthForm.value.consumeCigarettes == '0' ? this.healthForm.value.consumeCigarettesDescription : '',
              this.healthForm.value.seriousIllness == '' ? null : this.healthForm.value.seriousIllness == '0' ? true : false,
              this.healthForm.value.seriousIllness == '0' ? this.healthForm.value.seriousIllnessDescription : '',
              this.healthForm.value.dangerAtWork == '' ? null : this.healthForm.value.dangerAtWork == '0' ? true : false,
              this.healthForm.value.dangerAtWork == '0' ? this.healthForm.value.dangerAtWorkDescription : '',
              this.healthForm.value.tenYearMedicalTests == '' ? null : this.healthForm.value.tenYearMedicalTests == '0' ? true : false,
              this.healthForm.value.tenYearMedicalTests == '0' ? this.healthForm.value.tenYearmedicalTestsDescription : '',
              this.healthForm.value.thirtyDaysIncapable == '' ? null : this.healthForm.value.thirtyDaysIncapable == '0' ? true : false,
              this.healthForm.value.thirtyDaysIncapable == '0' ? this.healthForm.value.thirtyDaysIncapableDescription : '',
              this.healthForm.value.levelOfInvaliditet == '' ? null : this.healthForm.value.levelOfInvaliditet == '0' ? true : false,
              this.healthForm.value.levelOfInvaliditet == '0' ? this.healthForm.value.levelOfInvaliditetDescription : '',
              this.healthForm.value.newFifteenthQuestion == '0' ? true : this.healthForm.value.newFifteenthQuestion == '1' ? false : null,
              this.healthForm.value.newFifteenthQuestion == '0' ? this.healthForm.value.newFifteenthQuestionDescription : '',
              this.healthForm.value.nameOfDoctor,
              this.healthForm.value.familySickness == '0' ? true : this.healthForm.value.familySickness == '1' ? false : null,
              this.healthForm.value.familySickness == '0' ? this.healthForm.value.familySicknessDescription : '',
              this.healthForm.value.agreeToHealthQuestionnaire
            ),
            FATCAQuestionnaire: new FATCAQuestionnaire(
              0,
              null,
              null,
              null,
              null,
              null,
              null
            ),
            SPNFTForm: new SPNFTQuestionnaire(
              0,
              this.spnftForm.value.firstname ? this.spnftForm.value.firstname.toUpperCase() : '',
              this.spnftForm.value.lastname ? this.spnftForm.value.lastname.toUpperCase() : '',
              this.spnftForm.value.companyName ? this.spnftForm.value.companyName.toUpperCase() : '',
              this.spnftForm.value.jmbg ? this.spnftForm.value.jmbg : '',
              '',
              this.spnftForm.value.settlementob ? this.spnftForm.value.settlementob.toUpperCase() : '',
              this.spnftForm.value.address ? this.spnftForm.value.address.toUpperCase() : '',
              this.spnftForm.value.postalCode ? this.spnftForm.value.postalCode.toString() : "",
              this.spnftForm.value.settlement ? this.spnftForm.value.settlement.toUpperCase() : '',
              this.spnftForm.value.citizenship ? this.spnftForm.value.citizenship.toUpperCase() : '',
              this.spnftForm.value.legalRepresentativeFirstname ? this.spnftForm.value.legalRepresentativeFirstname.toUpperCase() : '',
              this.spnftForm.value.legalRepresentativeLastname ? this.spnftForm.value.legalRepresentativeLastname.toUpperCase() : '',
              this.spnftForm.value.representativeJmbg ? this.spnftForm.value.representativeJmbg : '',
              this.spnftForm.value.pib ? this.spnftForm.value.pib : '',
              this.spnftForm.value.mb ? this.spnftForm.value.mb : '',
              this.spnftForm.value.typeOfDocument ? this.spnftForm.value.typeOfDocument : '',
              this.spnftForm.value.numberOfDocument ? this.spnftForm.value.numberOfDocument : '',
              this.spnftForm.value.dateOfIssuringDocument ? this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0] : '',
              this.spnftForm.value.personalDocumentExpirationDate ? this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0] : '',
              this.spnftForm.value.placeOfIssuringDocument ? this.spnftForm.value.placeOfIssuringDocument.toUpperCase() : '',
              this.spnftForm.value.officialCloseFamily == 0 ? false : true,
              this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.officialPeriod : '',
              this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.closeFamilyName : '',
              this.spnftForm.value.cutomerAnotherPerson == '' ? null : this.spnftForm.value.cutomerAnotherPerson == '1' ? true : false,
              this.spnftForm.value.cutomerAnotherPersonRole ? this.spnftForm.value.cutomerAnotherPersonRole : null,
              this.spnftForm.value.firstnameOnBehalf ? this.spnftForm.value.firstnameOnBehalf.toUpperCase() : '',
              this.spnftForm.value.lastnameOnBehalf ? this.spnftForm.value.lastnameOnBehalf.toUpperCase() : '',
              this.spnftForm.value.jmbgOnBehalf ? this.spnftForm.value.jmbgOnBehalf : '',
              this.spnftForm.get('dobOnBehalf').value ? this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0] : '',
              this.spnftForm.value.settlementobOnBehalf ? this.spnftForm.value.settlementobOnBehalf.toUpperCase() : '',
              this.spnftForm.value.addressOnBehalf ? this.spnftForm.value.addressOnBehalf.toUpperCase() : '',
              this.spnftForm.value.postalCodeOnBehalf ? this.spnftForm.value.postalCodeOnBehalf.toString() : '',
              this.spnftForm.value.settlementOnBehalf ? this.spnftForm.value.settlementOnBehalf.toUpperCase() : '',
              this.spnftForm.value.idTypeOnBehalf ? this.spnftForm.value.idTypeOnBehalf : '',
              this.spnftForm.value.idNumberOnBehalf ? this.spnftForm.value.idNumberOnBehalf : '',
              this.spnftForm.value.idDate ? this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0] : '',
              this.spnftForm.value.idPlace ? this.spnftForm.value.idPlace.toUpperCase() : '',
              this.spnftForm.value.purposeOfBusinessRelation != '' ? this.spnftForm.value.purposeOfBusinessRelation : null,
              this.spnftForm.value.purposeOfBusinessRelation == '3' ? this.spnftForm.value.purposeOfBusinessRelationOther : '',
              this.spnftForm.value.originOfProperty != '' ? this.spnftForm.value.originOfProperty : null,
              this.spnftForm.value.originOfProperty == '3' ? this.spnftForm.value.originOfPropertyOther : ''
            ),
            PlatimatikForm: new PLATIMATICQuestionnaire(
              0,
              this.platimatikForm.value.firstname ? this.platimatikForm.value.firstname.toUpperCase() : '',
              this.platimatikForm.value.lastname ? this.platimatikForm.value.lastname.toUpperCase() : '',
              this.platimatikForm.value.address ? this.platimatikForm.value.address.toUpperCase() : '',
              this.platimatikForm.value.postalCode ? this.platimatikForm.value.postalCode.toString() : "",
              this.platimatikForm.value.placeOfResidence ? this.platimatikForm.value.placeOfResidence.toUpperCase() : '',
              this.platimatikForm.value.jmbg ? this.platimatikForm.value.jmbg : '',
              this.platimatikForm.value.bankName ? this.platimatikForm.value.bankName : '',
              this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber,
              this.platimatikForm.value.bankBic ? this.platimatikForm.value.bankBic : '',
              '',
              1,
              this.platimatikForm.get('validityFirstTermFrom').value ? this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0] : '',
              this.platimatikForm.get('validityFirstTermTo').value ? this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0] : '',
              this.platimatikForm.get('validitySecondTermFrom').value ? this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0] : '',
              this.platimatikForm.get('validitySecondTermTo').value ? this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0] : ''
            )
          })

          if (this.basicInfo.data.contractorType == '1') {
            this.draftModelFull.data.FATCAQuestionnaire.Q1NP = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q2NP = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
          } else {
            this.draftModelFull.data.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q1LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q2LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q3LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q4LE = false;
          }


          this.draftModelFull.data.PremiumRate = this.sentInformations.premiumRate;
          this.draftModelFull.data.AdditionalPremiumRateDeath = this.sentInformations.additionalPremiumRate
          this.draftModelFull.data.AdditionalInsuredSumDeath = this.sentInformations.additionalSumInsured
          this.draftModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
          this.draftModelFull.data.RedemptionAndCapitalization.OfferID = 0;

          if (!this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) {
            this.draftModelFull.data.AdditionalInsuranceType = 0;
            console.log("Personal")
            this.draftModelFull.data.DeathByAccident = this.personalForm.value.deathByAccident;
            this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;

            this.draftModelFull.data.AdditionalRiderDeath = this.personalForm.value.riderDeath;
            this.draftModelFull.data.AdditionalRiderTBType = Number(this.personalForm.value.tbType);
            this.draftModelFull.data.AdditionalRiderTB = this.personalForm.value.riderTB;
            if (this.personalForm.value.includeMSO == '0') {
              this.draftModelFull.data.IncludeMSO = false;
            } else {
              this.draftModelFull.data.IncludeMSO = true;
            }
            if (this.personalForm.value.includeDNA == '0') {
              this.draftModelFull.data.IncludeDNA = false;
            } else {
              this.draftModelFull.data.IncludeDNA = true;
            }
            if (this.personalForm.value.invalidityByAccident) {
              if (this.personalForm.value.surgery) {
                this.draftModelFull.data.Surgery = this.personalForm.value.surgery;
              } else {
                this.draftModelFull.data.Surgery = null;
              }
              if (this.personalForm.value.monthlyRent) {
                this.draftModelFull.data.MonthlyRent = this.personalForm.value.monthlyRent;
              } else {
                this.draftModelFull.data.MonthlyRent = null;
              }
              if (this.personalForm.value.daylyFee) {
                this.draftModelFull.data.DailyFee = this.personalForm.value.daylyFee;
              } else {
                this.draftModelFull.data.DailyFee = null
              }
              if (this.personalForm.value.treatmanExpenses) {
                this.draftModelFull.data.TreatmentExpenses = this.personalForm.value.treatmanExpenses;
              } else {
                this.draftModelFull.data.TreatmentExpenses = null;
              }
              this.draftModelFull.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
            } else {
              this.draftModelFull.data.InvalidityByAccident = null;
              this.draftModelFull.data.Surgery = null;
              this.draftModelFull.data.MonthlyRent = null;
              this.draftModelFull.data.DailyFee = null;
              this.draftModelFull.data.TreatmentExpenses = null;
              this.draftModelFull.data.IncludeMSO = false;
              this.draftModelFull.data.IncludeDNA = false;
            }
          } else if (this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) {
            this.draftModelFull.data.AdditionalInsuranceType = this.insuranceCoverageForm.value.accidentPlan;
            console.log("Dopunsko")
            this.draftModelFull.data.DeathByAccident = this.sentInformations.deathByAccident;
            this.draftModelFull.data.InvalidityByAccident = this.sentInformations.invalidityByAccident;
            this.draftModelFull.data.MonthlyRent = this.sentInformations.monthlyRent;
            this.draftModelFull.data.TreatmentExpenses = null;
            this.draftModelFull.data.DailyFee = null;
            switch (this.insuranceCoverageForm.value.accidentPlan) {
              case '1':
                this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
                this.draftModelFull.data.Surgery = null;
                this.draftModelFull.data.IncludeMSO = false;
                this.draftModelFull.data.IncludeDNA = false;
                break;
              case '2':
                this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
                this.draftModelFull.data.Surgery = this.sentInformations.surgery;
                this.draftModelFull.data.IncludeMSO = true;
                this.draftModelFull.data.IncludeDNA = false;
                break;
              case '3':
                this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
                this.draftModelFull.data.Surgery = this.sentInformations.surgery;
                this.draftModelFull.data.DailyFee = this.sentInformations.dailyFee;
                this.draftModelFull.data.IncludeMSO = false;
                this.draftModelFull.data.IncludeDNA = false;
                break;
              case '4':
                this.draftModelFull.data.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
                this.draftModelFull.data.Surgery = null;
                this.draftModelFull.data.IncludeMSO = true;
                this.draftModelFull.data.IncludeDNA = true;
                break;
              default:
                break;
            }
          } else {
            this.draftModelFull.data.AdditionalInsuranceType = 5;
            this.draftModelFull.data.DeathByAccident = null;
            this.draftModelFull.data.InvalidityByAccident = null;
            this.draftModelFull.data.Surgery = null;
            this.draftModelFull.data.TreatmentExpenses = null;
            this.draftModelFull.data.DailyFee = null;
            this.draftModelFull.data.MonthlyRent = null;
            this.draftModelFull.data.IncludeMSO = false;
            this.draftModelFull.data.IncludeDNA = true;
            this.draftModelFull.data.AdditionalPremiumRate = 0;
          }

          this.offerService.createDraftOffer(this.draftModelFull)
            .then(
              x => {
                this.successTitle = "Uspešno ste kreirali draft ponudu";
                this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
                this.resetAllForms()
                this.insuranceUsers = []
                this.formPlatimatikBool = false;
                this.formSpnftBool = false;
                this.noticeFatcaBool = false;
                this.healthQuestionnaireBool = false;
                this.calculcatorUsersBool = false;
                this.validInsuranceAndSumPremium = false;
                this.validUser = false;
                this.validSPNFT = false;
                this.validPLATIMATIK = false;
              },
              e => console.log(e)
            )

        }
      }
    }
  }


  validInsuranceAndSumPremium: Boolean = false;
  validUser: Boolean = false;
  validSPNFT: Boolean = false;
  validPLATIMATIK: Boolean = false;
  offerId;
  userValue;
  offerModelFull: StandardOSOffer;
  saveDigital() {
    // console.log(this.hideExport)
    // console.log(this.basicInfo.data)


    this.userValue = true;
    loop1:
    for (let i = 0; i < this.roles.length; i++) {
      loop2:
      for (let j = 0; j < this.insuranceUsers.length; j++) {
        if (this.roles[i].productRoleID == this.insuranceUsers[j].RoleID) {
          this.userValue = false;
          break loop2;
        }
      }
      if (i + 1 == this.roles.length) {
        if (!this.userValue) {
          break loop1;
        }
      }
      if (!this.userValue) {
        this.userValue = true
      } else {
        break loop1;
      }
    }


    let startDate = '';
    let endDate = '';
    if (this.insuredSumAndPremiumForm.get('insuranceStart').value) {
      startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
    } else {
      startDate = ''
    }
    if (this.insuredSumAndPremiumForm.get('insuranceEnd').value) {
      endDate = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0];
    } else {
      endDate = ''
    }

    this.offerModelFull = new StandardOSOffer({
      InsuranceStart: startDate,
      InsuranceEnd: endDate,
      OfferNumber: "",
      OfferType: 1,
      ContractorID: 0,
      InsureeID: 0,
      OneTimePayment: false,
      PaymentPeriodMonths: 0,
      Interest: 0,
      CreditAmount: 0,
      AdditionalIL: false,
      AdditionalBF: false,
      AdditionalAS: false,
      Contractor: new OfferClient(
        this.basicInfo.data.contractorType == '1' ? '1' : '0',
        this.basicInfo.data.contractorFirstname,
        this.basicInfo.data.contractorLastname,
        this.basicInfo.data.contractorResponsibleName,
        this.basicInfo.data.contractorJMBG,
        this.basicInfo.data.contractorPhonenumber,
        this.basicInfo.data.contractorEmail,
        this.basicInfo.data.contractorAddress,
        this.basicInfo.data.contractorSettlement,
        this.basicInfo.data.contractorPostalCode,
        this.basicInfo.data.contractorAddressOfDelivery,
        this.basicInfo.data.contractorSettlementOfDelivery,
        this.basicInfo.data.contractorPostalCodeOfDelivery,
        0,
        "",
        ""
      ),
      Insuree: new OfferInsuree(
        this.basicInfo.data.insuredFirstname,
        this.basicInfo.data.insuredLastname,
        this.basicInfo.data.insuredJMBG,
        this.basicInfo.data.insuredDOB,
        this.basicInfo.data.insuredMobile,
        this.basicInfo.data.insuredEmail,
        this.basicInfo.data.insuredAddress,
        this.basicInfo.data.insuredSettlement,
        this.basicInfo.data.insuredPostalCode,
        this.basicInfo.data.insuredJob,
        0,
        0
      ),
      Gender: this.insuredSumAndPremiumForm.value.gender,
      ContractorIsInsuree: this.basicInfo.data.contractorCopy,
      HazardLevel: 2,
      CigarettesPerDay: parseInt(this.basicInfoForm.value.cigarettesDaily),
      Height: parseInt(this.basicInfoForm.value.height),
      Weight: this.basicInfoForm.value.weight,
      AdditionalInsuranceDeath: this.basicInfoForm.value.deathSuppInsurance == '0' ? false : true,
      PaymentPeriodOut: 5,
      PaymentPeriodIn: this.insuredSumAndPremiumForm.value.scholarshipPeriodPayout,
      StartingAge: this.insuredSumAndPremiumForm.value.accessAge,
      Duration: parseInt(this.insuredSumAndPremiumForm.get('insurancePeriod').value),
      SumInsured: this.basicInfoForm.value.insuranceSum,
      PaymentPeriod: 0,
      RentPaymentFrequency: 0,
      RentPayment: 0,
      PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
      PaymentType: parseInt(this.insuredSumAndPremiumForm.value.methodPayment),
      ProductType: 7,
      ClientStatusID: null,
      PaymentInCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayment),
      PaymentOutCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayout),
      Comment: "",
      UserID: this.userId,
      NotificationsAgreement: this.checkBoxesForm.value.confirmSMS == '1' ? true : false,
      Verified: this.checkBoxesForm.value.confirmVeracity,
      Verified2: this.checkBoxesForm.value.confirmVeracity,
      Verified3: this.checkBoxesForm.value.confirmEmail == '1' ? true : false,
      Beneficiaries: this.insuranceUsers,
      RedemptionAndCapitalization: new RedemptionAndCapitalizations(),
      HealthQuestionnaire: new HealthQuestionnaire(
        0,
        this.healthForm.value.threeMonthStayAbroad == '0' ? true : false,
        this.healthForm.value.threeMonthStayAbroad == '0' ? this.healthForm.value.threeMonthStayAbroadDescription : '',
        this.healthForm.value.deniedAcceptedRequest == '0' ? true : false,
        this.healthForm.value.deniedAcceptedRequest == '0' ? this.healthForm.value.deniedacceptedRequestDescription : '',
        this.healthForm.value.sportActivity == '0' ? true : false,
        this.healthForm.value.sportActivity == '0' ? this.healthForm.value.sportActivityDescription : '',
        this.healthForm.value.constantDoctorTreats == '0' ? true : false,
        this.healthForm.value.constantDoctorTreats == '0' ? this.healthForm.value.constantDoctorTreatsDescription : '',
        this.healthForm.value.specialMedicalExamination == '0' ? true : false,
        this.healthForm.value.specialMedicalExamination == '0' ? this.healthForm.value.specialMedicalExaminationDescription : '',
        this.healthForm.value.takingMedicines == '0' ? true : false,
        this.healthForm.value.takingMedicines == '0' ? this.healthForm.value.takingMedicinesDescription : '',
        this.healthForm.value.alcoholOrIntoxicants == '0' ? true : false,
        this.healthForm.value.alcoholOrIntoxicants == '0' ? this.healthForm.value.alcoholOrIntoxicantsDescription : '',
        this.healthForm.value.helpForAlcoholAddiction == '0' ? true : false,
        this.healthForm.value.helpForAlcoholAddiction == '0' ? this.healthForm.value.helpForAlcoholAddictionDescription : '',
        this.healthForm.value.consumeCigarettes == '0' ? true : false,
        this.healthForm.value.consumeCigarettes == '0' ? this.healthForm.value.consumeCigarettesDescription : '',
        this.healthForm.value.seriousIllness == '0' ? true : false,
        this.healthForm.value.seriousIllness == '0' ? this.healthForm.value.seriousIllnessDescription : '',
        this.healthForm.value.dangerAtWork == '0' ? true : false,
        this.healthForm.value.dangerAtWork == '0' ? this.healthForm.value.dangerAtWorkDescription : '',
        this.healthForm.value.tenYearMedicalTests == '0' ? true : false,
        this.healthForm.value.tenYearMedicalTests == '0' ? this.healthForm.value.tenYearmedicalTestsDescription : '',
        this.healthForm.value.thirtyDaysIncapable == '0' ? true : false,
        this.healthForm.value.thirtyDaysIncapable == '0' ? this.healthForm.value.thirtyDaysIncapableDescription : '',
        this.healthForm.value.levelOfInvaliditet == '0' ? true : false,
        this.healthForm.value.levelOfInvaliditet == '0' ? this.healthForm.value.levelOfInvaliditetDescription : '',
        this.healthForm.value.newFifteenthQuestion == '0' ? true : this.healthForm.value.newFifteenthQuestion == '1' ? false : null,
        this.healthForm.value.newFifteenthQuestion == '0' ? this.healthForm.value.newFifteenthQuestionDescription : '',
        this.healthForm.value.nameOfDoctor,
        this.healthForm.value.familySickness == '0' ? true : this.healthForm.value.familySickness == '1' ? false : null,
        this.healthForm.value.familySickness == '0' ? this.healthForm.value.familySicknessDescription : '',
        this.healthForm.value.agreeToHealthQuestionnaire
      ),
      FATCAQuestionnaire: new FATCAQuestionnaire(
        0
      ),
      SPNFTForm: new SPNFTQuestionnaire(
        0,
        this.spnftForm.value.firstname ? this.spnftForm.value.firstname.toUpperCase() : '',
        this.spnftForm.value.lastname ? this.spnftForm.value.lastname.toUpperCase() : '',
        this.spnftForm.value.companyName ? this.spnftForm.value.companyName.toUpperCase() : '',
        this.spnftForm.value.jmbg,
        '',
        this.spnftForm.value.settlementob ? this.spnftForm.value.settlementob.toUpperCase() : '',
        this.spnftForm.value.address ? this.spnftForm.value.address.toUpperCase() : '',
        this.spnftForm.value.postalCode,
        this.spnftForm.value.settlement ? this.spnftForm.value.settlement.toUpperCase() : '',
        this.spnftForm.value.citizenship ? this.spnftForm.value.citizenship.toUpperCase() : '',
        this.spnftForm.value.legalRepresentativeFirstname ? this.spnftForm.value.legalRepresentativeFirstname.toUpperCase() : '',
        this.spnftForm.value.legalRepresentativeLastname ? this.spnftForm.value.legalRepresentativeLastname.toUpperCase() : '',
        this.spnftForm.value.representativeJmbg,
        this.spnftForm.value.pib,
        this.spnftForm.value.mb,
        this.spnftForm.value.typeOfDocument,
        this.spnftForm.value.numberOfDocument,
        '',
        this.spnftForm.value.personalDocumentExpirationDate ? this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0] : '',
        this.spnftForm.value.placeOfIssuringDocument ? this.spnftForm.value.placeOfIssuringDocument.toUpperCase() : '',
        this.spnftForm.value.officialCloseFamily == 0 ? false : true,
        this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.officialPeriod : '',
        this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.closeFamilyName : '',
        !this.spnftForm.value.cutomerAnotherPerson ? false : this.spnftForm.value.cutomerAnotherPerson == '1' ? true : false,
        this.spnftForm.value.cutomerAnotherPersonRole ? this.spnftForm.value.cutomerAnotherPersonRole : null,
        this.spnftForm.value.firstnameOnBehalf ? this.spnftForm.value.firstnameOnBehalf.toUpperCase() : '',
        this.spnftForm.value.lastnameOnBehalf ? this.spnftForm.value.lastnameOnBehalf.toUpperCase() : '',
        this.spnftForm.value.jmbgOnBehalf,
        '',
        this.spnftForm.value.settlementobOnBehalf ? this.spnftForm.value.settlementobOnBehalf.toUpperCase() : '',
        this.spnftForm.value.addressOnBehalf ? this.spnftForm.value.addressOnBehalf.toUpperCase() : '',
        this.spnftForm.value.postalCodeOnBehalf,
        this.spnftForm.value.settlementOnBehalf ? this.spnftForm.value.settlementOnBehalf.toUpperCase() : '',
        this.spnftForm.value.idTypeOnBehalf,
        this.spnftForm.value.idNumberOnBehalf,
        '',
        this.spnftForm.value.idPlace ? this.spnftForm.value.idPlace.toUpperCase() : '',
        this.spnftForm.value.purposeOfBusinessRelation,
        this.spnftForm.value.purposeOfBusinessRelation == '3' ? this.spnftForm.value.purposeOfBusinessRelationOther : '',
        this.spnftForm.value.originOfProperty,
        this.spnftForm.value.originOfProperty == '3' ? this.spnftForm.value.originOfPropertyOther : ''
      ),
      PlatimatikForm: new PLATIMATICQuestionnaire(
        0,
        this.platimatikForm.value.firstname ? this.platimatikForm.value.firstname.toUpperCase() : '',
        this.platimatikForm.value.lastname ? this.platimatikForm.value.lastname.toUpperCase() : '',
        this.platimatikForm.value.address ? this.platimatikForm.value.address.toUpperCase() : '',
        this.platimatikForm.value.postalCode,
        this.platimatikForm.value.placeOfResidence ? this.platimatikForm.value.placeOfResidence.toUpperCase() : '',
        this.platimatikForm.value.jmbg,
        this.platimatikForm.value.bankName,
        this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber,
        this.platimatikForm.value.bankBic,
        '',
        1,
        this.platimatikForm.get('validityFirstTermFrom').value ? this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0] : '',
        this.platimatikForm.get('validityFirstTermTo').value ? this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0] : '',
        this.platimatikForm.get('validitySecondTermFrom').value ? this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0] : '',
        this.platimatikForm.get('validitySecondTermTo').value ? this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0] : '',
      )
    })
    if (this.spnftForm.get('dobOnBehalf').value) {
      this.offerModelFull.data.SPNFTForm.IntermediaryDateOfBirth = this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.IntermediaryDateOfBirth = ''
    }
    if (this.spnftForm.get('dob').value) {
      this.offerModelFull.data.SPNFTForm.DateOfBirth = this.spnftForm.get('dob').value.split('.')[2] + '-' + this.spnftForm.get('dob').value.split('.')[1] + '-' + this.spnftForm.get('dob').value.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.DateOfBirth = ''
    }
    if (this.spnftForm.value.dateOfIssuringDocument) {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = ''
    }
    if (this.spnftForm.value.personalDocumentExpirationDate) {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = ''
    }
    if (this.spnftForm.value.idDate) {
      this.offerModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = ''
    }
    if (this.basicInfo.data.contractorType == '1') {
      this.offerModelFull.data.Contractor.TaxID = this.basicInfo.data.contractorPIB;
      this.offerModelFull.data.Contractor.CompanyID = this.basicInfo.data.contractorID;
      this.offerModelFull.data.Contractor.ClientType = '1';
      this.offerModelFull.data.FATCAQuestionnaire.Q1NP = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q2NP = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
    } else {
      this.offerModelFull.data.Contractor.TaxID = '';
      this.offerModelFull.data.Contractor.CompanyID = '';
      this.offerModelFull.data.Contractor.ClientType = '0';
      this.offerModelFull.data.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q1LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q2LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q3LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q4LE = false;
    }
    if (this.insuredSumAndPremiumForm.value.indexation == '0') {
      this.offerModelFull.data.Indexation = false;
    } else {
      this.offerModelFull.data.Indexation = true;
    }



    let helthBool = false;
    if (
      !this.healthForm.value.threeMonthStayAbroad ||
      (this.healthForm.value.threeMonthStayAbroad == '0' && !this.healthForm.value.threeMonthStayAbroadDescription) ||
      !this.healthForm.value.deniedAcceptedRequest ||
      (this.healthForm.value.deniedAcceptedRequest == '0' && !this.healthForm.value.deniedacceptedRequestDescription) ||
      !this.healthForm.value.sportActivity ||
      (this.healthForm.value.sportActivity == '0' && !this.healthForm.value.sportActivityDescription) ||
      !this.healthForm.value.constantDoctorTreats ||
      (this.healthForm.value.constantDoctorTreats == '0' && !this.healthForm.value.constantDoctorTreatsDescription) ||
      !this.healthForm.value.specialMedicalExamination ||
      (this.healthForm.value.specialMedicalExamination == '0' && !this.healthForm.value.specialMedicalExaminationDescription) ||
      !this.healthForm.value.takingMedicines ||
      (this.healthForm.value.takingMedicines == '0' && !this.healthForm.value.takingMedicinesDescription) ||
      !this.healthForm.value.alcoholOrIntoxicants ||
      (this.healthForm.value.alcoholOrIntoxicants == '0' && !this.healthForm.value.alcoholOrIntoxicantsDescription) ||
      !this.healthForm.value.helpForAlcoholAddiction ||
      (this.healthForm.value.helpForAlcoholAddiction == '0' && !this.healthForm.value.helpForAlcoholAddictionDescription) ||
      !this.healthForm.value.consumeCigarettes ||
      (this.healthForm.value.consumeCigarettes == '0' && !this.healthForm.value.consumeCigarettesDescription) ||
      !this.healthForm.value.seriousIllness ||
      (this.healthForm.value.seriousIllness == '0' && !this.healthForm.value.seriousIllnessDescription) ||
      !this.healthForm.value.dangerAtWork ||
      (this.healthForm.value.dangerAtWork == '0' && !this.healthForm.value.dangerAtWorkDescription) ||
      !this.healthForm.value.tenYearMedicalTests ||
      (this.healthForm.value.tenYearMedicalTests == '0' && !this.healthForm.value.tenYearmedicalTestsDescription) ||
      !this.healthForm.value.thirtyDaysIncapable ||
      (this.healthForm.value.thirtyDaysIncapable == '0' && !this.healthForm.value.thirtyDaysIncapableDescription) ||
      !this.healthForm.value.levelOfInvaliditet ||
      (this.healthForm.value.levelOfInvaliditet == '0' && !this.healthForm.value.levelOfInvaliditetDescription) ||
      !this.healthForm.value.newFifteenthQuestion ||
      (this.healthForm.value.newFifteenthQuestion == '0' && !this.healthForm.value.newFifteenthQuestionDescription) ||
      !this.healthForm.value.nameOfDoctor ||
      // (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription) ||
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) && !this.healthForm.value.familySickness) ||
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) && (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription)) ||
      !this.healthForm.value.agreeToHealthQuestionnaire
    ) {
      helthBool = true;
    } else {
      helthBool = false;
    }

    if (
      (this.healthForm.value.consumeCigarettes == '0' && this.basicInfoForm.value.cigarettesDaily == 0) ||
      (this.healthForm.value.consumeCigarettes == '1' && this.basicInfoForm.value.cigarettesDaily > 0)
    ) {
      this.errorTitle = "Odgovor na ponudi u vezi cigareta nije usklađen sa upitnikom. Molimo ispravite odgovor na ponudi.";
      this.modalService.open(this.alertModal, { centered: true })
      return;
    }


    // console.log(mobileRegex.test(this.basicInfo.data.contractorPhonenumber.toString()))
    // console.log(offer)
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      this.offerModelFull.data.PremiumRate = this.sentInformations.premiumRate;
      this.offerModelFull.data.AdditionalPremiumRateDeath = this.sentInformations.additionalPremiumRate
      this.offerModelFull.data.AdditionalInsuredSumDeath = this.sentInformations.additionalSumInsured
      this.offerModelFull.data.RedemptionAndCapitalization.RCTable = JSON.stringify(this.sentInformations.standardTable)
      this.offerModelFull.data.RedemptionAndCapitalization.OfferID = 0;

      if (!this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) {
        console.log("Personal")
        this.offerModelFull.data.AdditionalInsuranceType = 0;
        this.offerModelFull.data.DeathByAccident = this.personalForm.value.deathByAccident;
        this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;

        this.offerModelFull.data.AdditionalRiderDeath = this.personalForm.value.riderDeath;
        this.offerModelFull.data.AdditionalRiderTBType = Number(this.personalForm.value.tbType);
        this.offerModelFull.data.AdditionalRiderTB = this.personalForm.value.riderTB;
        if (this.personalForm.value.includeMSO == '0') {
          this.offerModelFull.data.IncludeMSO = false;
        } else {
          this.offerModelFull.data.IncludeMSO = true;
        }
        if (this.personalForm.value.includeDNA == '0') {
          this.offerModelFull.data.IncludeDNA = false;
        } else {
          this.offerModelFull.data.IncludeDNA = true;
        }
        if (this.personalForm.value.invalidityByAccident) {
          if (this.personalForm.value.surgery) {
            this.offerModelFull.data.Surgery = this.personalForm.value.surgery;
          } else {
            this.offerModelFull.data.Surgery = null;
          }
          if (this.personalForm.value.monthlyRent) {
            this.offerModelFull.data.MonthlyRent = this.personalForm.value.monthlyRent;
          } else {
            this.offerModelFull.data.MonthlyRent = null;
          }
          if (this.personalForm.value.daylyFee) {
            this.offerModelFull.data.DailyFee = this.personalForm.value.daylyFee;
          } else {
            this.offerModelFull.data.DailyFee = null
          }
          if (this.personalForm.value.treatmanExpenses) {
            this.offerModelFull.data.TreatmentExpenses = this.personalForm.value.treatmanExpenses;
          } else {
            this.offerModelFull.data.TreatmentExpenses = null;
          }
          this.offerModelFull.data.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
        } else {
          this.offerModelFull.data.InvalidityByAccident = null;
          this.offerModelFull.data.Surgery = null;
          this.offerModelFull.data.MonthlyRent = null;
          this.offerModelFull.data.DailyFee = null;
          this.offerModelFull.data.TreatmentExpenses = null;
          this.offerModelFull.data.IncludeMSO = false;
          this.offerModelFull.data.IncludeDNA = false;
        }
      } else if (this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) {
        console.log("Dopunsko")
        this.offerModelFull.data.AdditionalInsuranceType = this.insuranceCoverageForm.value.accidentPlan;
        this.offerModelFull.data.DeathByAccident = this.sentInformations.deathByAccident;
        this.offerModelFull.data.InvalidityByAccident = this.sentInformations.invalidityByAccident;
        this.offerModelFull.data.MonthlyRent = this.sentInformations.monthlyRent;
        this.offerModelFull.data.TreatmentExpenses = null;
        this.offerModelFull.data.DailyFee = null;
        switch (this.insuranceCoverageForm.value.accidentPlan) {
          case '1':
            this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
            this.offerModelFull.data.Surgery = null;
            this.offerModelFull.data.IncludeMSO = false;
            this.offerModelFull.data.IncludeDNA = false;
            break;
          case '2':
            this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
            this.offerModelFull.data.Surgery = this.sentInformations.surgery;
            this.offerModelFull.data.IncludeMSO = true;
            this.offerModelFull.data.IncludeDNA = false;
            break;
          case '3':
            this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
            this.offerModelFull.data.Surgery = this.sentInformations.surgery;
            this.offerModelFull.data.DailyFee = this.sentInformations.dailyFee;
            this.offerModelFull.data.IncludeMSO = false;
            this.offerModelFull.data.IncludeDNA = false;
            break;
          case '4':
            this.offerModelFull.data.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
            this.offerModelFull.data.Surgery = null;
            this.offerModelFull.data.IncludeMSO = true;
            this.offerModelFull.data.IncludeDNA = true;
            break;
          default:
            break;
        }
      } else {
        this.offerModelFull.data.AdditionalInsuranceType = 5;
        this.offerModelFull.data.DeathByAccident = null;
        this.offerModelFull.data.InvalidityByAccident = null;
        this.offerModelFull.data.Surgery = null;
        this.offerModelFull.data.TreatmentExpenses = null;
        this.offerModelFull.data.DailyFee = null;
        this.offerModelFull.data.MonthlyRent = null;
        this.offerModelFull.data.IncludeMSO = false;
        this.offerModelFull.data.IncludeDNA = true;
        this.offerModelFull.data.AdditionalPremiumRate = 0;
      }

      if (!this.userSignature) {
        this.errorTitle = "Nemate potpis";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (
          ((this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.accidentPlan == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.accidentPlan == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.accidentPlan == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.accidentPlan == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (!this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
        ) {
          this.errorTitle = "Ne možete napraviti digitalnu ponudu ukoliko godisnja premija nije manja od 1500 €";
          this.modalService.open(this.alertModal, { centered: true })
        } else {

          let mobileRegex = new RegExp('0[0-9]{7,9}')
          let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
          if (this.basicInfo.data.contractorType == '1') {
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || !this.basicInfo.data.contractorPIB || !this.basicInfo.data.contractorResponsibleName || !this.basicInfo.data.contractorID || this.basicInfo.data.contractorJMBG.length != 13 || this.basicInfo.data.contractorPIB.length != 9 || this.basicInfo.data.contractorID.length != 8) {
              this.digitalService.addInfo(true);
            } else {
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !emailRegex.test(this.basicInfo.data.insuredEmail.toString()) || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                this.digitalService.addInfo(true);
              } else {
                if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.indexation || !this.insuredSumAndPremiumForm.value.methodPayment) {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      if (!this.fatcaForm.value.insuredLegalEntitySad || !this.fatcaForm.value.insuredTaxpayerSad || !this.fatcaForm.value.insuredTenPrecentShare || !this.fatcaForm.value.insuredFinancialInstitution) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname || !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13) {
              console.log("Prosle basic")
              console.log(this.basicInfo)
              this.digitalService.addInfo(true);
            } else {
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !emailRegex.test(this.basicInfo.data.insuredEmail.toString()) || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                console.log('prosole insured')
                this.digitalService.addInfo(true);
              } else {
                if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.indexation || !this.insuredSumAndPremiumForm.value.methodPayment) {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  console.log("Prosle currency")
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    console.log("Prosli korisnici")
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      console.log("Prosao zdravstveni")
                      if (!this.fatcaForm.value.citizenshipSad || !this.fatcaForm.value.texpayerSad) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname ||
                          !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          console.log("Prosao spnft")
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              console.log("Prosao platiomatik")
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }


  resetCalculation() {
    this.hideExport = false;
    if (this.basicInfoForm.value.cigarettesDaily > 0) {
      this.healthForm.get('consumeCigarettes').setValue('0')
      this.healthForm.get('consumeCigarettesDescription').setValue(this.basicInfoForm.value.cigarettesDaily.toString())
    } else {
      this.healthForm.get('consumeCigarettes').setValue('1')
      this.healthForm.get('consumeCigarettesDescription').setValue('')
    }
    if (this.basicInfo.data.insuredJMBG) {
      if (this.basicInfo.data.insuredJMBG.length >= 7) {
        if (this.basicInfo.data.insuredJMBG.substring(4, 5) == '0') {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        } else {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        }
      }
      // if (this.basicInfo.data.insuredJMBG.length >= 12) {
      //   if (parseInt(this.basicInfo.data.insuredJMBG.substring(9, 12)) < 500) {
      //     if (this.insuredSumAndPremiumForm.value.gender == 'Ž') {
      //       this.insuredSumAndPremiumForm.get('gender').setValue('M')
      //     }
      //   } else {
      //     if (this.insuredSumAndPremiumForm.value.gender == 'M') {
      //       this.insuredSumAndPremiumForm.get('gender').setValue('Ž')
      //     }
      //   }
      // }
    }
  }

  insuredSumAndPremiumHide() {
    this.insuredSumANdPremimBool = !this.insuredSumANdPremimBool;
  }
  basicCaseHide() {
    this.basicCaseBool = !this.basicCaseBool;
  }
  supplementaryInsuranceHide() {
    this.supplementaryInsuranceBool = !this.supplementaryInsuranceBool;
  }
  calculcatorUsersHide() {
    this.calculcatorUsersBool = !this.calculcatorUsersBool;
  }
  healthQuestionnaireHide() {
    this.healthQuestionnaireBool = !this.healthQuestionnaireBool;
  }
  noticePersonalityHide() {
    this.noticePersonalityBool = !this.noticePersonalityBool;
  }
  noticeFatcaHide() {
    this.noticeFatcaBool = !this.noticeFatcaBool;
  }
  formSpnftHide() {
    this.formSpnftBool = !this.formSpnftBool;
  }
  formPlatimatikHide() {
    this.formPlatimatikBool = !this.formPlatimatikBool;
  }

  noSupplementaryHide() {
    if (this.basicInfoForm.value.noSupplementaryInsurance) {
      this.supplementaryIsnuranceHideAllBool = true;
    } else {
      this.supplementaryIsnuranceHideAllBool = false;
    }
    this.resetCalculation()
  }

  roles;
  getRoles() {
    this.productRoleService.getRoleByProduct(7)
      .subscribe(
        (res) => {
          this.roles = res;
          // console.log(this.roles)
        }
      )
  }

  get validInsuredSumAndPremiumForm() {
    return this.insuredSumAndPremiumForm.controls;
  }

  get validHealthForm() {
    return this.healthForm.controls;
  }

  setSPNFTDate() {
    if (this.spnftForm.value.jmbg.length >= 7) {
      if (this.spnftForm.value.jmbg.substring(4, 5) == '0') {
        this.spnftForm.get('dob').setValue(this.spnftForm.value.jmbg.substring(0, 2) + "." + this.spnftForm.value.jmbg.substring(2, 4) + '.2' + this.spnftForm.value.jmbg.substring(4, 7))
      } else {
        this.spnftForm.get('dob').setValue(this.spnftForm.value.jmbg.substring(0, 2) + "." + this.spnftForm.value.jmbg.substring(2, 4) + '.1' + this.spnftForm.value.jmbg.substring(4, 7))
      }
    } else {
      this.spnftForm.get('dob').setValue('')
    }
  }

  setdobOnBehalf() {
    if (this.spnftForm.value.jmbgOnBehalf.length >= 7) {
      if (this.spnftForm.value.jmbgOnBehalf.substring(4, 5) == '0') {
        this.spnftForm.get('dobOnBehalf').setValue(this.spnftForm.value.jmbgOnBehalf.substring(0, 2) + "." + this.spnftForm.value.jmbgOnBehalf.substring(2, 4) + '.2' + this.spnftForm.value.jmbgOnBehalf.substring(4, 7))
      } else {
        this.spnftForm.get('dobOnBehalf').setValue(this.spnftForm.value.jmbgOnBehalf.substring(0, 2) + "." + this.spnftForm.value.jmbgOnBehalf.substring(2, 4) + '.1' + this.spnftForm.value.jmbgOnBehalf.substring(4, 7))
      }
    } else {
      this.spnftForm.get('dobOnBehalf').setValue('')
    }
  }

  occupationArray;
  getOccupation() {
    this.occupationArray = this.occupationService.gridView(new Filter({ Top: null, Page: null, Filter: {}, Sort: {} }))
  }

  userId;
  userSignature;
  getUser() {
    this.userService.getUser()
      .then(
        (x: { id: Number, signature: String }) => {
          this.userId = x.id;
          this.userSignature = x.signature;
        }
      )
  }

  resetEverything() {
    this.insuredSumAndPremiumForm.reset({ currencyPayment: '0', currencyPayout: '0', scholarshipPeriodPayment: '5' })
    this.todayDate = new Date()
    this.todayDate.setDate(1);
    this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.basicInfoForm.reset();
    this.healthForm.reset({ agreeToHealthQuestionnaire: true })
    this.fatcaForm.reset({
      citizenshipSad: '1',
      texpayerSad: '1',
      insuredLegalEntitySad: '1',
      insuredTaxpayerSad: '1',
      insuredTenPrecentShare: '1',
      insuredFinancialInstitution: '1'
    })
    this.standardTableArray = []
    this.spnftForm.reset({ officialCloseFamily: '0' })
    this.platimatikForm.reset()
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.hideExport = false;
    this.insuranceCoverageForm.reset({ accidentPlan: '3', planRadio: '2' })
    this.personalForm.reset({ includeMSO: '0', includeDNA: '0', planRadio: '2', tbType: '' })
    this.noCovrageForm.reset({ planRadio: '2' })
    this.checkBoxesForm.reset({ confirmVeracity: false, confirmData: false, confirmSMS: '1', confirmEmail: '1', offer: true, redemptionAndCapitalization: false, proContract: false, terms: false, doctor: false })
    this.removeInfoService.sendOfferID(true);
    this.insuranceUsers = []
    this.validInsuranceAndSumPremium = false;
    this.validUser = false;
    this.validSPNFT = true;
    this.validPLATIMATIK = false;
    this.calculcatorUsersBool = false;
    this.healthQuestionnaireBool = false;
    this.noticePersonalityBool = false;
    this.noticeFatcaBool = false;
    this.formSpnftBool = false;
    this.basicInfo = new BasicInformations({});
  }

}
